import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { useInView } from 'react-intersection-observer';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Link } from 'react-router-dom';
const makeClassName = list => {
  return list.filter(_ref => {
    let [, active] = _ref;
    return active;
  }).map(_ref2 => {
    let [className] = _ref2;
    return className;
  }).join(' ');
};
const ButtonLoader = () => (/*#__PURE__*/React.createElement("svg", {
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S2 22.18 2 15 7.82 2 15 2z",
  opacity: "0.3"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 15 15",
  to: "360 15 15",
  dur: "1000ms",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 0c8.18 0 14.83 6.547 14.997 14.686L30 15h-2c0-7.077-5.655-12.833-12.693-12.996L15 2V0z"
}))));
var styles$J = {
  "root": "Button-module_root__9OQ5b",
  "gold": "Button-module_gold__q-XBP",
  "isLoading": "Button-module_isLoading__Z53G4",
  "gray": "Button-module_gray__fypDq",
  "sand": "Button-module_sand__e5v-k",
  "dark": "Button-module_dark__qv4NQ",
  "light": "Button-module_light__TLYLT",
  "black": "Button-module_black__GIsbk",
  "red": "Button-module_red__kybni",
  "default": "Button-module_default__utLb-",
  "isInToolbar": "Button-module_isInToolbar__84SG-",
  "isInPodcast": "Button-module_isInPodcast__SNSpl",
  "isInSpoiler": "Button-module_isInSpoiler__pGp-w",
  "ghost": "Button-module_ghost__1s5-r",
  "isInDropdown": "Button-module_isInDropdown__gN7TI",
  "loader": "Button-module_loader__r0Mjs",
  "isFancy": "Button-module_isFancy__gTRmu"
};
const Button = _ref3 => {
  let {
    theme = 'gold',
    size = 'default',
    state = 'isDefault',
    styleContext = 'isInToolbar',
    appearance,
    disabled = false,
    onClick,
    children
  } = _ref3;
  const handleClick = () => {
    if (disabled || !onClick) {
      return;
    }
    onClick();
  };
  return /*#__PURE__*/React.createElement("button", {
    "data-testid": "button",
    className: makeClassName([[styles$J.root, true], [styles$J[size], !!size], [styles$J[theme], !!theme], [styles$J[appearance], !!appearance], [styles$J[state], !!state && !!styles$J[state]], [styles$J[styleContext], !!styleContext]]),
    disabled: disabled,
    onClick: handleClick,
    type: "button"
  }, state === 'isLoading' ? (/*#__PURE__*/React.createElement("span", {
    className: styles$J.loader
  }, /*#__PURE__*/React.createElement(ButtonLoader, null))) : children);
};
const icons = {
  meduzaLogo: {
    width: 544,
    height: 115,
    content: '<path d="M59.1008614,49.65632 L59.1008614,106.01472 L84.9480411,114.24 L84.9480411,49.65632 L101.574882,49.65632 L101.574882,106.01472 L127.270909,114.24 L144.048902,91.392 L127.422062,91.392 L127.422062,35.7952 L101.726035,26.80832 L84.9480411,46.60992 L84.9480411,35.7952 L59.2520145,26.80832 L42.4740206,46.60992 L42.4740206,35.7952 L16.7779939,26.80832 L0,49.65632 L16.6268408,49.65632 L16.6268408,106.01472 L42.4740206,114.24 L42.4740206,49.65632 L59.1008614,49.65632 L59.1008614,49.65632 Z M336.61795,91.392 L336.61795,35.0336 L310.770769,26.80832 L310.770769,105.25312 L336.466796,114.24 L353.24479,94.4384 L353.24479,105.25312 L378.940817,114.24 L395.71881,91.392 L379.091969,91.392 L379.091969,35.0336 L353.24479,26.80832 L353.24479,91.392 L336.61795,91.392 L336.61795,91.392 Z M527.373159,38.08 L502.130592,26.80832 L472.202278,41.1264 L502.130592,52.39808 L461.016949,72.352 L461.016949,104.94848 L486.86413,114.24 L502.130592,94.28608 L502.130592,105.25312 L527.977771,114.24 L544,91.23968 L527.373159,91.23968 L527.373159,38.08 L527.373159,38.08 Z M177.453737,114.24 L207.079744,102.35904 L177.453737,91.23968 L177.453737,75.24608 L216.300083,56.3584 L194.231731,26.80832 L151.606557,47.37152 L151.606557,103.12064 L177.453737,114.24 L177.453737,114.24 Z M455.424284,89.56416 L423.984441,79.968 L453.459295,42.19264 L416.577937,26.80832 L397.230341,51.48416 L428.821339,61.23264 L398.741873,98.85568 L436.076687,114.24 L455.424284,89.56416 L455.424284,89.56416 Z M486.86413,91.392 L486.86413,68.84864 L502.130592,61.53728 L502.130592,91.392 L486.86413,91.392 L486.86413,91.392 Z M177.453737,41.58336 L190.452904,59.55712 L177.453737,65.80224 L177.453737,41.58336 L177.453737,41.58336 Z M222.95082,103.12064 L248.797999,114.24 L291.27202,97.18016 L291.27202,29.7024 L222.95082,0 L222.95082,26.30784 L265.424841,43.21536 L265.424841,97.33248 L248.797999,91.23968 L248.797999,43.71584 L222.95082,51.94112 L222.95082,103.12064 L222.95082,103.12064 Z" />'
  },
  menu: {
    width: 24,
    height: 24,
    content: '<path d="M2 21h20M2 12h20M2 3h20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />'
  },
  fb: {
    width: 16,
    height: 18,
    content: '<path d="M15.117 1H.883A.883.883 0 0 0 0 1.883v14.234A.883.883 0 0 0 .883 17h7.663v-6.196H6.461V8.389h2.085V6.61a2.91 2.91 0 0 1 3.106-3.192c.622-.003 1.244.03 1.863.095v2.16h-1.279c-1.002 0-1.196.476-1.196 1.176v1.541h2.39l-.31 2.415h-2.08V17h4.077a.883.883 0 0 0 .883-.883V1.883A.883.883 0 0 0 15.117 1" />'
  },
  tw: {
    width: 20,
    height: 18,
    content: '<path d="M20 3.1c-.7.3-1.5.6-2.4.7.8-.5 1.5-1.4 1.8-2.4-.8.5-1.7.8-2.6 1-.7-.8-1.8-1.4-3-1.4-2.3 0-4.1 1.9-4.1 4.3 0 .3 0 .7.1 1-3.3-.1-6.4-1.8-8.4-4.4-.3.6-.5 1.4-.5 2.2 0 1.5.7 2.8 1.8 3.6-.7 0-1.3-.2-1.9-.5v.1c0 2.1 1.4 3.8 3.3 4.2-.3.1-.7.2-1.1.2-.3 0-.5 0-.8-.1.5 1.7 2 2.9 3.8 3-1.3 1-3.1 1.6-5 1.6-.3 0-.7 0-1-.1C1.8 17.3 4 18 6.3 18 13.8 18 18 11.5 18 5.8v-.6c.8-.5 1.5-1.2 2-2.1" fill-rule="nonzero"/>'
  },
  vk: {
    width: 20,
    height: 18,
    content: '<path d="M16.517 9.851s2.587-3.768 2.886-5.058c.1-.396-.1-.694-.498-.694h-2.288c-.498 0-.697.199-.896.595 0 0-1.194 2.678-2.686 4.364-.498.496-.697.694-.995.694-.2 0-.299-.198-.299-.694V4.793c0-.595-.1-.793-.597-.793H7.463c-.2 0-.398.198-.398.397 0 .595.796.694.796 2.28v3.174c0 .595 0 .893-.299.893-.796 0-2.686-2.777-3.681-5.851-.2-.595-.398-.794-.995-.794H.597C.299 4.1 0 4.298 0 4.694c0 .595.697 3.471 3.483 7.34C5.373 14.611 7.86 16 10.05 16c1.393 0 1.691-.198 1.691-.793v-1.984c0-.496.2-.694.498-.694s.895.1 2.189 1.388C15.92 15.405 16.02 16 16.915 16h2.587c.299 0 .498-.1.498-.595 0-.595-.796-1.587-1.89-2.876-.498-.595-1.195-1.29-1.493-1.686-.398-.397-.299-.595-.1-.992" fill-rule="nonzero"/>'
  },
  ok: {
    width: 9,
    height: 18,
    content: '<path d="M4.5 2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m0 5.7c-.9 0-1.6-.8-1.6-1.7 0-.9.7-1.6 1.6-1.6.9 0 1.7.7 1.7 1.7 0 .8-.8 1.6-1.7 1.6" fill-rule="nonzero"/> <path d="M6.127 12.982a9.194 9.194 0 0 0 2.307-.904c.602-.301.703-1.004.402-1.507-.301-.502-1.104-.703-1.605-.401-1.605 1.004-3.812 1.004-5.417 0-.502-.302-1.304-.201-1.605.3-.401.604-.2 1.206.401 1.608a9.194 9.194 0 0 0 2.307.904L.61 15.092c-.502.401-.502 1.104 0 1.607a1.357 1.357 0 0 0 1.705 0l2.207-2.11L6.73 16.7a1.357 1.357 0 0 0 1.705 0c.502-.402.502-1.105 0-1.608l-2.307-2.109" fill-rule="nonzero"/>'
  },
  tg: {
    width: 18,
    height: 18,
    content: '<path d="M9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm-1.5-7.4c1.1 1 2 3.3 2 3.3.4.2.7.1.8-.4l2.1-7.4c.1-.6-.2-.8-.6-.7L4 8.3c-.6.2-.6.5-.1.7 0 .1 2.4.6 3.6 1.6z" fill-rule="nonzero"/>'
  },
  meduzaSymbol: {
    width: 24,
    height: 18,
    content: '<path d="M10.026233,17.0968697 L13.9737671,18.3530831 L13.9737671,10.9855851 L13.9737671,8.48948164 L16.5131165,8.48948164 L16.5131165,17.0968697 L20.4375656,18.3530831 L23,14.8636014 L20.4606507,14.8636014 L20.4606507,6.37252945 L16.5362015,5 L13.9737671,8.02421743 L13.9737671,6.37252945 L10.049318,5 L7.48688354,8.02421743 L7.48688354,6.37252945 L3.56243443,5 L1,8.48948164 L3.53934943,8.48948164 L3.53934943,17.0968697 L7.48688354,18.3530831 L7.48688354,8.48948164 L10.026233,8.48948164 L10.026233,17.0968697 Z" />'
  },
  backward: {
    width: 30,
    height: 30,
    content: '<g opacity="0.25" fill="none"><path d="M6.51621 7.01524H6.51404C4.34188 9.1874 3 12.1877 3 15.5001C3 22.1271 8.37187 27.5012 15.0011 27.5012C21.6281 27.5012 27 22.1271 27 15.5001C27 8.87306 21.6281 3.49902 15.0011 3.49902" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15 6.49902V0.499023L10 3.49902L15 6.49902Z" fill="black" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.1778 20.098C10.6178 20.098 10.1838 19.636 10.1838 19.104V13.224L9.16179 14.274C9.00779 14.428 8.79779 14.526 8.57379 14.526C8.11179 14.526 7.74779 14.148 7.74779 13.7C7.74779 13.462 7.84579 13.266 7.98579 13.112L10.1978 10.9C10.4078 10.69 10.7018 10.564 11.0238 10.564C11.6538 10.564 12.1718 11.082 12.1718 11.712V19.104C12.1718 19.636 11.7238 20.098 11.1778 20.098ZM14.4426 19.314C14.2186 19.174 14.0506 18.88 14.0506 18.586C14.0506 18.096 14.4426 17.704 14.9326 17.704C15.1006 17.704 15.2686 17.746 15.4086 17.844C15.9826 18.25 16.6406 18.432 17.3686 18.432C18.4746 18.432 19.1046 17.802 19.1046 17.032C19.1046 16.178 18.4886 15.604 17.4246 15.604C16.8086 15.604 16.2906 15.758 15.8006 16.136C15.6186 16.276 15.3946 16.346 15.1426 16.346C14.5546 16.346 14.0786 15.87 14.0786 15.282V11.712C14.0786 11.04 14.4426 10.662 15.1286 10.662H19.7346C20.1966 10.662 20.6026 11.04 20.6026 11.53C20.6026 11.992 20.1966 12.37 19.7346 12.37H16.0246V14.708C16.5146 14.274 17.2706 13.924 18.1246 13.924C19.7066 13.924 21.1206 15.058 21.1206 16.948C21.1206 18.922 19.6366 20.168 17.3826 20.168C16.1646 20.168 15.2126 19.86 14.4426 19.314Z" fill="black"/></g>'
  },
  forward: {
    width: 30,
    height: 30,
    content: '<g opacity="0.25" fill="none"><path d="M23.4838 7.01524H23.486C25.6581 9.1874 27 12.1877 27 15.5001C27 22.1271 21.6281 27.5012 14.9989 27.5012C8.37187 27.5012 3 22.1271 3 15.5001C3 8.87306 8.37187 3.49902 14.9989 3.49902" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15 6.49902V0.499023L20 3.49902L15 6.49902Z" fill="black" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.1778 20.098C10.6178 20.098 10.1838 19.636 10.1838 19.104V13.224L9.16179 14.274C9.00779 14.428 8.79779 14.526 8.57379 14.526C8.11179 14.526 7.74779 14.148 7.74779 13.7C7.74779 13.462 7.84579 13.266 7.98579 13.112L10.1978 10.9C10.4078 10.69 10.7018 10.564 11.0238 10.564C11.6538 10.564 12.1718 11.082 12.1718 11.712V19.104C12.1718 19.636 11.7238 20.098 11.1778 20.098ZM14.4426 19.314C14.2186 19.174 14.0506 18.88 14.0506 18.586C14.0506 18.096 14.4426 17.704 14.9326 17.704C15.1006 17.704 15.2686 17.746 15.4086 17.844C15.9826 18.25 16.6406 18.432 17.3686 18.432C18.4746 18.432 19.1046 17.802 19.1046 17.032C19.1046 16.178 18.4886 15.604 17.4246 15.604C16.8086 15.604 16.2906 15.758 15.8006 16.136C15.6186 16.276 15.3946 16.346 15.1426 16.346C14.5546 16.346 14.0786 15.87 14.0786 15.282V11.712C14.0786 11.04 14.4426 10.662 15.1286 10.662H19.7346C20.1966 10.662 20.6026 11.04 20.6026 11.53C20.6026 11.992 20.1966 12.37 19.7346 12.37H16.0246V14.708C16.5146 14.274 17.2706 13.924 18.1246 13.924C19.7066 13.924 21.1206 15.058 21.1206 16.948C21.1206 18.922 19.6366 20.168 17.3826 20.168C16.1646 20.168 15.2126 19.86 14.4426 19.314Z" fill="black"/></g>'
  },
  download: {
    width: 25,
    height: 27,
    content: '<path d="M12.5 2C19.404 2 25 7.596 25 14.5S19.404 27 12.5 27 0 21.404 0 14.5 5.596 2 12.5 2zm0 1.5c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11zm6 15.75a.75.75 0 01.102 1.493l-.102.007h-12a.75.75 0 01-.102-1.493l.102-.007h12zm-6-12a.75.75 0 01.743.648L13.25 8v7.598l1.834-1.222a.75.75 0 11.832 1.248l-3 2a.75.75 0 01-.832 0l-3-2a.75.75 0 11.832-1.248l1.834 1.223V8a.75.75 0 01.648-.743l.102-.007z" fill-rule="nonzero" fill="currentColor" />'
  },
  episodeDownload: {
    width: 30,
    height: 30,
    content: '<g opacity="0.4"><circle cx="15" cy="15" r="10.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M15 19.5L15 10.5M15 19.5L18.5 17.2257M15 19.5L11.5 17.2257" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></g>'
  },
  play: {
    width: 32,
    height: 32,
    content: '<path fill-rule="nonzero" clip-rule="evenodd" d="M11.9665 22.877C11.4713 23.1557 10.8594 22.7978 10.8594 22.2296V9.7704C10.8594 9.20219 11.4713 8.84435 11.9665 9.12299L23.0374 15.3526C23.5422 15.6366 23.5422 16.3634 23.0374 16.6474L11.9665 22.877Z" stroke-width="0.371429" stroke-linecap="round" stroke-linejoin="round"/>'
  },
  pause: {
    width: 22,
    height: 22,
    content: '<path d="M12.832 4h2.8c.276 0 .5.224.5.5v12.394c0 .277-.224.5-.5.5h-2.8c-.276 0-.5-.223-.5-.5V4.5c0-.276.224-.5.5-.5zM6.5 4h2.8c.277 0 .5.224.5.5v12.394c0 .277-.223.5-.5.5H6.5c-.276 0-.5-.223-.5-.5V4.5c0-.276.224-.5.5-.5z" />'
  },
  speedHalf: {
    width: 27,
    height: 11,
    content: `<g xmlns="http://www.w3.org/2000/svg" opacity="0.25">
                <path d="M24.0086 6.10773L22.3566 7.75973C22.2586 7.85773 22.1186 7.92773 21.9646 7.92773C21.6566 7.92773 21.4186 7.67573 21.4186 7.38173C21.4186 7.22773 21.4886 7.08773 21.5726 6.98973L23.2246 5.32373L21.5726 3.67173C21.4886 3.57373 21.4186 3.43373 21.4186 3.27973C21.4186 2.97173 21.6566 2.71973 21.9646 2.71973C22.1186 2.71973 22.2726 2.78973 22.3706 2.88773L24.0086 4.55373L25.6606 2.88773C25.7586 2.78973 25.9126 2.73373 26.0526 2.73373C26.3606 2.73373 26.6126 2.97173 26.6126 3.27973C26.6126 3.43373 26.5426 3.57373 26.4446 3.67173L24.7926 5.32373L26.4446 6.98973C26.5426 7.08773 26.6126 7.22773 26.6126 7.38173C26.6126 7.67573 26.3606 7.91373 26.0526 7.91373C25.9126 7.91373 25.7726 7.85773 25.6746 7.75973L24.0086 6.10773Z" fill="black"/>
                <path d="M13.307 9.31411C13.083 9.17411 12.915 8.88011 12.915 8.58611C12.915 8.09611 13.307 7.70411 13.797 7.70411C13.965 7.70411 14.133 7.74611 14.273 7.84411C14.847 8.25011 15.505 8.43211 16.233 8.43211C17.339 8.43211 17.969 7.80211 17.969 7.03211C17.969 6.17811 17.353 5.60411 16.289 5.60411C15.673 5.60411 15.155 5.75811 14.665 6.13611C14.483 6.27611 14.259 6.34611 14.007 6.34611C13.419 6.34611 12.943 5.87011 12.943 5.28211V1.71211C12.943 1.04011 13.307 0.662109 13.993 0.662109H18.599C19.061 0.662109 19.467 1.04011 19.467 1.53011C19.467 1.99211 19.061 2.37011 18.599 2.37011H14.889V4.70811C15.379 4.27411 16.135 3.92411 16.989 3.92411C18.571 3.92411 19.985 5.05811 19.985 6.94811C19.985 8.92211 18.501 10.1681 16.247 10.1681C15.029 10.1681 14.077 9.86011 13.307 9.31411Z" fill="black"/>
                <path d="M9.03894 9.01974C9.03894 8.40374 9.55694 7.88574 10.1729 7.88574C10.7889 7.88574 11.3069 8.40374 11.3069 9.01974C11.3069 9.63574 10.7889 10.1537 10.1729 10.1537C9.55694 10.1537 9.03894 9.63574 9.03894 9.01974Z" fill="black"/>
                <path d="M0.476074 5.33748C0.476074 2.92948 1.66607 0.521484 4.34007 0.521484C7.00007 0.521484 8.20407 2.92948 8.20407 5.33748C8.20407 7.74548 7.00007 10.1675 4.34007 10.1675C1.66607 10.1675 0.476074 7.74548 0.476074 5.33748ZM6.17407 5.33748C6.17407 3.61548 5.67007 2.28549 4.34007 2.28549C2.99607 2.28549 2.49207 3.61548 2.49207 5.33748C2.49207 7.05948 2.99607 8.40349 4.34007 8.40349C5.67007 8.40349 6.17407 7.05948 6.17407 5.33748Z" fill="black"/>
              </g>`
  },
  speedThreeQuarters: {
    width: 34,
    height: 11,
    content: `<g xmlns="http://www.w3.org/2000/svg" opacity="0.25">
                <path d="M30.6531 6.10773L29.0011 7.75973C28.9031 7.85773 28.7631 7.92773 28.6091 7.92773C28.3011 7.92773 28.0631 7.67573 28.0631 7.38173C28.0631 7.22773 28.1331 7.08773 28.2171 6.98973L29.8691 5.32373L28.2171 3.67173C28.1331 3.57373 28.0631 3.43373 28.0631 3.27973C28.0631 2.97173 28.3011 2.71973 28.6091 2.71973C28.7631 2.71973 28.9171 2.78973 29.0151 2.88773L30.6531 4.55373L32.3051 2.88773C32.4031 2.78973 32.5571 2.73373 32.6971 2.73373C33.0051 2.73373 33.2571 2.97173 33.2571 3.27973C33.2571 3.43373 33.1871 3.57373 33.0891 3.67173L31.4371 5.32373L33.0891 6.98973C33.1871 7.08773 33.2571 7.22773 33.2571 7.38173C33.2571 7.67573 33.0051 7.91373 32.6971 7.91373C32.5571 7.91373 32.4171 7.85773 32.3191 7.75973L30.6531 6.10773Z" fill="black"/>
                <path d="M19.9516 9.31411C19.7276 9.17411 19.5596 8.88011 19.5596 8.58611C19.5596 8.09611 19.9516 7.70411 20.4416 7.70411C20.6096 7.70411 20.7776 7.74611 20.9176 7.84411C21.4916 8.25011 22.1496 8.43211 22.8776 8.43211C23.9836 8.43211 24.6136 7.80211 24.6136 7.03211C24.6136 6.17811 23.9976 5.60411 22.9336 5.60411C22.3176 5.60411 21.7996 5.75811 21.3096 6.13611C21.1276 6.27611 20.9036 6.34611 20.6516 6.34611C20.0636 6.34611 19.5876 5.87011 19.5876 5.28211V1.71211C19.5876 1.04011 19.9516 0.662109 20.6376 0.662109H25.2436C25.7056 0.662109 26.1116 1.04011 26.1116 1.53011C26.1116 1.99211 25.7056 2.37011 25.2436 2.37011H21.5336V4.70811C22.0236 4.27411 22.7796 3.92411 23.6336 3.92411C25.2156 3.92411 26.6296 5.05811 26.6296 6.94811C26.6296 8.92211 25.1456 10.1681 22.8916 10.1681C21.6736 10.1681 20.7216 9.86011 19.9516 9.31411Z" fill="black"/>
                <path d="M14.1437 10.0981C13.5977 10.0981 13.1497 9.65011 13.1497 9.10411C13.1497 8.96411 13.1917 8.83811 13.2337 8.69811L16.0197 2.41211H12.0997C11.6237 2.41211 11.2177 2.02011 11.2177 1.54411C11.2177 1.05411 11.6237 0.662109 12.0997 0.662109H17.4757C17.9937 0.662109 18.4277 1.08211 18.4277 1.61411C18.4277 1.75411 18.3997 1.88011 18.3437 1.99211L15.0677 9.49611C14.9277 9.86011 14.5637 10.0981 14.1437 10.0981Z" fill="black"/>
                <path d="M9.03894 9.01974C9.03894 8.40374 9.55694 7.88574 10.1729 7.88574C10.7889 7.88574 11.3069 8.40374 11.3069 9.01974C11.3069 9.63574 10.7889 10.1537 10.1729 10.1537C9.55694 10.1537 9.03894 9.63574 9.03894 9.01974Z" fill="black"/>
                <path d="M0.476074 5.33748C0.476074 2.92948 1.66607 0.521484 4.34007 0.521484C7.00007 0.521484 8.20407 2.92948 8.20407 5.33748C8.20407 7.74548 7.00007 10.1675 4.34007 10.1675C1.66607 10.1675 0.476074 7.74548 0.476074 5.33748ZM6.17407 5.33748C6.17407 3.61548 5.67007 2.28549 4.34007 2.28549C2.99607 2.28549 2.49207 3.61548 2.49207 5.33748C2.49207 7.05948 2.99607 8.40349 4.34007 8.40349C5.67007 8.40349 6.17407 7.05948 6.17407 5.33748Z" fill="black"/>
              </g>`
  },
  speedOne: {
    width: 25,
    height: 10,
    content: `<g xmlns="http://www.w3.org/2000/svg" opacity="0.25">
                <path d="M21.9901 5.60773L20.3381 7.25973C20.2401 7.35773 20.1001 7.42773 19.9461 7.42773C19.6381 7.42773 19.4001 7.17573 19.4001 6.88173C19.4001 6.72773 19.4701 6.58773 19.5541 6.48973L21.2061 4.82373L19.5541 3.17173C19.4701 3.07373 19.4001 2.93373 19.4001 2.77973C19.4001 2.47173 19.6381 2.21973 19.9461 2.21973C20.1001 2.21973 20.2541 2.28973 20.3521 2.38773L21.9901 4.05373L23.6421 2.38773C23.7401 2.28973 23.8941 2.23373 24.0341 2.23373C24.3421 2.23373 24.5941 2.47173 24.5941 2.77973C24.5941 2.93373 24.5241 3.07373 24.4261 3.17173L22.7741 4.82373L24.4261 6.48973C24.5241 6.58773 24.5941 6.72773 24.5941 6.88173C24.5941 7.17573 24.3421 7.41373 24.0341 7.41373C23.8941 7.41373 23.7541 7.35773 23.6561 7.25973L21.9901 5.60773Z" fill="black"/>
                <path d="M10.2565 4.83748C10.2565 2.42948 11.4465 0.0214844 14.1205 0.0214844C16.7805 0.0214844 17.9845 2.42948 17.9845 4.83748C17.9845 7.24548 16.7805 9.66749 14.1205 9.66749C11.4465 9.66749 10.2565 7.24548 10.2565 4.83748ZM15.9545 4.83748C15.9545 3.11548 15.4505 1.78549 14.1205 1.78549C12.7765 1.78549 12.2725 3.11548 12.2725 4.83748C12.2725 6.55948 12.7765 7.90349 14.1205 7.90349C15.4505 7.90349 15.9545 6.55948 15.9545 4.83748Z" fill="black"/>
                <path d="M6.85645 8.51974C6.85645 7.90374 7.37445 7.38574 7.99045 7.38574C8.60645 7.38574 9.12444 7.90374 9.12444 8.51974C9.12444 9.13574 8.60645 9.65374 7.99045 9.65374C7.37445 9.65374 6.85645 9.13574 6.85645 8.51974Z" fill="black"/>
                <path d="M4.27766 9.59748C3.71766 9.59748 3.28366 9.13548 3.28366 8.60348V2.72348L2.26166 3.77348C2.10766 3.92748 1.89766 4.02548 1.67366 4.02548C1.21166 4.02548 0.847656 3.64748 0.847656 3.19948C0.847656 2.96148 0.945656 2.76548 1.08566 2.61148L3.29766 0.399477C3.50766 0.189477 3.80166 0.0634766 4.12366 0.0634766C4.75366 0.0634766 5.27166 0.581477 5.27166 1.21148V8.60348C5.27166 9.13548 4.82366 9.59748 4.27766 9.59748Z" fill="black"/>
              </g>`
  },
  speedOneQuarter: {
    width: 33,
    height: 11,
    content: `<g xmlns="http://www.w3.org/2000/svg" opacity="0.25">
                <path d="M29.6005 6.10773L27.9485 7.75973C27.8505 7.85773 27.7105 7.92773 27.5565 7.92773C27.2485 7.92773 27.0105 7.67573 27.0105 7.38173C27.0105 7.22773 27.0805 7.08773 27.1645 6.98973L28.8165 5.32373L27.1645 3.67173C27.0805 3.57373 27.0105 3.43373 27.0105 3.27973C27.0105 2.97173 27.2485 2.71973 27.5565 2.71973C27.7105 2.71973 27.8645 2.78973 27.9625 2.88773L29.6005 4.55373L31.2525 2.88773C31.3505 2.78973 31.5045 2.73373 31.6445 2.73373C31.9525 2.73373 32.2045 2.97173 32.2045 3.27973C32.2045 3.43373 32.1345 3.57373 32.0365 3.67173L30.3845 5.32373L32.0365 6.98973C32.1345 7.08773 32.2045 7.22773 32.2045 7.38173C32.2045 7.67573 31.9525 7.91373 31.6445 7.91373C31.5045 7.91373 31.3645 7.85773 31.2665 7.75973L29.6005 6.10773Z" fill="black"/>
                <path d="M18.899 9.31411C18.675 9.17411 18.507 8.88011 18.507 8.58611C18.507 8.09611 18.899 7.70411 19.389 7.70411C19.557 7.70411 19.725 7.74611 19.865 7.84411C20.439 8.25011 21.097 8.43211 21.825 8.43211C22.931 8.43211 23.561 7.80211 23.561 7.03211C23.561 6.17811 22.945 5.60411 21.881 5.60411C21.265 5.60411 20.747 5.75811 20.257 6.13611C20.075 6.27611 19.851 6.34611 19.599 6.34611C19.011 6.34611 18.535 5.87011 18.535 5.28211V1.71211C18.535 1.04011 18.899 0.662109 19.585 0.662109H24.191C24.653 0.662109 25.059 1.04011 25.059 1.53011C25.059 1.99211 24.653 2.37011 24.191 2.37011H20.481V4.70811C20.971 4.27411 21.727 3.92411 22.581 3.92411C24.163 3.92411 25.577 5.05811 25.577 6.94811C25.577 8.92211 24.093 10.1681 21.839 10.1681C20.621 10.1681 19.669 9.86011 18.899 9.31411Z" fill="black"/>
                <path d="M10.7532 9.99949C10.1932 9.99949 9.71716 9.53749 9.71716 8.96348C9.71716 8.62748 9.89916 8.31948 10.1512 8.13748C13.7072 5.54748 14.7572 4.62348 14.7572 3.50348C14.7572 2.69148 14.0152 2.28549 13.2312 2.28549C12.4612 2.28549 11.8172 2.52348 11.2572 2.91548C11.1172 3.01348 10.9492 3.06948 10.7672 3.06948C10.2772 3.06948 9.88516 2.67748 9.88516 2.18748C9.88516 1.89348 10.0392 1.62748 10.2492 1.47348C11.1172 0.815485 12.1812 0.521484 13.2032 0.521484C15.1912 0.521484 16.7732 1.64148 16.7732 3.50348C16.7732 5.09948 15.4572 6.48549 12.9512 8.24949H16.0592C16.5352 8.24949 16.9412 8.64149 16.9412 9.11749C16.9412 9.60748 16.5352 9.99949 16.0592 9.99949H10.7532Z" fill="black"/>
                <path d="M6.37305 9.01974C6.37305 8.40374 6.89105 7.88574 7.50705 7.88574C8.12305 7.88574 8.64105 8.40374 8.64105 9.01974C8.64105 9.63574 8.12305 10.1537 7.50705 10.1537C6.89105 10.1537 6.37305 9.63574 6.37305 9.01974Z" fill="black"/>
                <path d="M3.79426 10.0975C3.23426 10.0975 2.80026 9.63548 2.80026 9.10348V3.22348L1.77826 4.27348C1.62426 4.42748 1.41426 4.52548 1.19026 4.52548C0.728258 4.52548 0.364258 4.14748 0.364258 3.69948C0.364258 3.46148 0.462258 3.26548 0.602258 3.11148L2.81426 0.899477C3.02426 0.689477 3.31826 0.563477 3.64026 0.563477C4.27026 0.563477 4.78826 1.08148 4.78826 1.71148V9.10348C4.78826 9.63548 4.34026 10.0975 3.79426 10.0975Z" fill="black"/>
              </g>`
  },
  speedOneHalf: {
    width: 24,
    height: 11,
    content: `<g xmlns="http://www.w3.org/2000/svg" opacity="0.25">
                <path d="M21.3427 6.1087L19.6907 7.7607C19.5927 7.8587 19.4527 7.9287 19.2987 7.9287C18.9907 7.9287 18.7527 7.6767 18.7527 7.3827C18.7527 7.2287 18.8227 7.0887 18.9067 6.9907L20.5587 5.3247L18.9067 3.6727C18.8227 3.5747 18.7527 3.4347 18.7527 3.2807C18.7527 2.9727 18.9907 2.7207 19.2987 2.7207C19.4527 2.7207 19.6067 2.7907 19.7047 2.8887L21.3427 4.5547L22.9947 2.8887C23.0927 2.7907 23.2467 2.7347 23.3867 2.7347C23.6947 2.7347 23.9467 2.9727 23.9467 3.2807C23.9467 3.4347 23.8767 3.5747 23.7787 3.6727L22.1267 5.3247L23.7787 6.9907C23.8767 7.0887 23.9467 7.2287 23.9467 7.3827C23.9467 7.6767 23.6947 7.9147 23.3867 7.9147C23.2467 7.9147 23.1067 7.8587 23.0087 7.7607L21.3427 6.1087Z" fill="black"/>
                <path d="M10.6411 9.31411C10.4171 9.17411 10.2491 8.88011 10.2491 8.58611C10.2491 8.09611 10.6411 7.70411 11.1311 7.70411C11.2991 7.70411 11.4671 7.74611 11.6071 7.84411C12.1811 8.25011 12.8391 8.43211 13.5671 8.43211C14.6731 8.43211 15.3031 7.80211 15.3031 7.03211C15.3031 6.17811 14.6871 5.60411 13.6231 5.60411C13.0071 5.60411 12.4891 5.75811 11.9991 6.13611C11.8171 6.27611 11.5931 6.34611 11.3411 6.34611C10.7531 6.34611 10.2771 5.87011 10.2771 5.28211V1.71211C10.2771 1.04011 10.6411 0.662109 11.3271 0.662109H15.9331C16.3951 0.662109 16.8011 1.04011 16.8011 1.53011C16.8011 1.99211 16.3951 2.37011 15.9331 2.37011H12.2231V4.70811C12.7131 4.27411 13.4691 3.92411 14.3231 3.92411C15.9051 3.92411 17.3191 5.05811 17.3191 6.94811C17.3191 8.92211 15.8351 10.1681 13.5811 10.1681C12.3631 10.1681 11.4111 9.86011 10.6411 9.31411Z" fill="black"/>
                <path d="M6.37305 9.02072C6.37305 8.40472 6.89105 7.88672 7.50705 7.88672C8.12305 7.88672 8.64105 8.40472 8.64105 9.02072C8.64105 9.63672 8.12305 10.1547 7.50705 10.1547C6.89105 10.1547 6.37305 9.63672 6.37305 9.02072Z" fill="black"/>
                <path d="M3.79426 10.0985C3.23426 10.0985 2.80026 9.63645 2.80026 9.10445V3.22445L1.77826 4.27445C1.62426 4.42845 1.41426 4.52645 1.19026 4.52645C0.728258 4.52645 0.364258 4.14845 0.364258 3.70045C0.364258 3.46245 0.462258 3.26645 0.602258 3.11245L2.81426 0.900453C3.02426 0.690453 3.31826 0.564453 3.64026 0.564453C4.27026 0.564453 4.78826 1.08245 4.78826 1.71245V9.10445C4.78826 9.63645 4.34026 10.0985 3.79426 10.0985Z" fill="black"/>
              </g>`
  },
  speedTwo: {
    width: 27,
    height: 11,
    content: `<g xmlns="http://www.w3.org/2000/svg" opacity="0.25">
                <path d="M24.0494 6.10773L22.3974 7.75973C22.2994 7.85773 22.1594 7.92773 22.0054 7.92773C21.6974 7.92773 21.4594 7.67573 21.4594 7.38173C21.4594 7.22773 21.5294 7.08773 21.6134 6.98973L23.2654 5.32373L21.6134 3.67173C21.5294 3.57373 21.4594 3.43373 21.4594 3.27973C21.4594 2.97173 21.6974 2.71973 22.0054 2.71973C22.1594 2.71973 22.3134 2.78973 22.4114 2.88773L24.0494 4.55373L25.7014 2.88773C25.7994 2.78973 25.9534 2.73373 26.0934 2.73373C26.4014 2.73373 26.6534 2.97173 26.6534 3.27973C26.6534 3.43373 26.5834 3.57373 26.4854 3.67173L24.8334 5.32373L26.4854 6.98973C26.5834 7.08773 26.6534 7.22773 26.6534 7.38173C26.6534 7.67573 26.4014 7.91373 26.0934 7.91373C25.9534 7.91373 25.8134 7.85773 25.7154 7.75973L24.0494 6.10773Z" fill="black"/>
                <path d="M12.3157 5.33748C12.3157 2.92948 13.5057 0.521484 16.1797 0.521484C18.8397 0.521484 20.0437 2.92948 20.0437 5.33748C20.0437 7.74548 18.8397 10.1675 16.1797 10.1675C13.5057 10.1675 12.3157 7.74548 12.3157 5.33748ZM18.0137 5.33748C18.0137 3.61548 17.5097 2.28549 16.1797 2.28549C14.8357 2.28549 14.3317 3.61548 14.3317 5.33748C14.3317 7.05948 14.8357 8.40349 16.1797 8.40349C17.5097 8.40349 18.0137 7.05948 18.0137 5.33748Z" fill="black"/>
                <path d="M8.91565 9.01974C8.91565 8.40374 9.43365 7.88574 10.0496 7.88574C10.6656 7.88574 11.1836 8.40374 11.1836 9.01974C11.1836 9.63574 10.6656 10.1537 10.0496 10.1537C9.43365 10.1537 8.91565 9.63574 8.91565 9.01974Z" fill="black"/>
                <path d="M1.45592 9.99949C0.895922 9.99949 0.419922 9.53749 0.419922 8.96348C0.419922 8.62748 0.601922 8.31948 0.853922 8.13748C4.40992 5.54748 5.45992 4.62348 5.45992 3.50348C5.45992 2.69148 4.71792 2.28549 3.93392 2.28549C3.16392 2.28549 2.51992 2.52348 1.95992 2.91548C1.81992 3.01348 1.65192 3.06948 1.46992 3.06948C0.979922 3.06948 0.587922 2.67748 0.587922 2.18748C0.587922 1.89348 0.741922 1.62748 0.951922 1.47348C1.81992 0.815485 2.88392 0.521484 3.90592 0.521484C5.89392 0.521484 7.47592 1.64148 7.47592 3.50348C7.47592 5.09948 6.15992 6.48549 3.65392 8.24949H6.76192C7.23792 8.24949 7.64392 8.64149 7.64392 9.11749C7.64392 9.60748 7.23792 9.99949 6.76192 9.99949H1.45592Z" fill="black"/>
              </g>`
  },
  podcastBookmark: {
    width: 25,
    height: 27,
    content: '<path d="M12.5 27C19.404 27 25 21.404 25 14.5S19.404 2 12.5 2 0 7.596 0 14.5 5.596 27 12.5 27zm0-1.5c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11z" /> <path d="M17.071 8.25H8a.75.75 0 00-.75.75v11.545l.007.104a.75.75 0 001.228.468l4.05-3.437 4.051 3.437a.75.75 0 001.235-.572V9a.75.75 0 00-.75-.75zm-.75 1.499v9.176l-3.3-2.8-.098-.07a.75.75 0 00-.873.07l-3.3 2.799V9.749h7.571z" data-stroke="true" /> <path d="M17.071 8.25H8a.75.75 0 00-.75.75v11.545l.007.104a.75.75 0 001.228.468l4.05-3.437 4.051 3.437a.75.75 0 001.235-.572V9a.75.75 0 00-.75-.75z" data-fill="true" />'
  },
  reaction: {
    width: 16,
    height: 16,
    content: '<path data-theme="light" fill="#D09959" d="M1 2h14v12H1z"/> <path d="M0 1.778C0 .8.8 0 1.778 0h12.444C15.2 0 16 .8 16 1.778v12.444C16 15.2 15.2 16 14.222 16H1.778C.8 16 0 15.2 0 14.222V1.778zM6.8 11.7l2.5.8V6.2h1.6v5.5l2.5.8 1.6-2.3h-1.6V4.8L10.9 4 9.3 5.9V4.8L6.8 4 5.1 5.9V4.8L2.6 4 1 6.2h1.6v5.5l2.5.8V6.2h1.7v5.5z" />'
  },
  cross: {
    width: 18,
    height: 18,
    content: '<path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" vector-effect="non-scaling-stroke" d="M2 2l14 14M16 2L2 16" />'
  },
  link: {
    width: 24,
    height: 24,
    content: '<path d="M9.158 18.928c-1.065 0-2.13-.405-2.94-1.215-1.624-1.623-1.624-4.262 0-5.884l.643-.645c.327-.326.854-.326 1.18 0 .325.326.325.853 0 1.178l-.645.645c-.972.972-.972 2.554 0 3.526.973.972 2.554.973 3.526 0l2.842-2.84c.97-.972.97-2.555 0-3.527-.325-.325-.325-.854 0-1.18.325-.324.853-.324 1.178 0 1.623 1.625 1.623 4.264 0 5.885l-2.84 2.84c-.81.81-1.877 1.216-2.942 1.216" /> <path d="M10.578 14.184c-.213 0-.426-.082-.59-.244-.784-.785-1.217-1.83-1.217-2.94 0-1.113.433-2.158 1.22-2.944l2.84-2.84c1.622-1.62 4.26-1.62 5.883 0 1.622 1.623 1.622 4.262 0 5.883l-.645.643c-.325.326-.852.326-1.178 0-.325-.325-.325-.852 0-1.178l.645-.644c.972-.97.972-2.554 0-3.526s-2.556-.972-3.527 0l-2.84 2.842c-.47.47-.73 1.096-.73 1.762 0 .667.26 1.293.73 1.763.325.327.325.854 0 1.18-.163.162-.376.244-.59.244" />'
  },
  search: {
    width: 16,
    height: 16,
    content: '<g transform="translate(2 1)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" vector-effect="non-scaling-stroke"><circle cx="5.5" cy="5.5" r="5.5"/><path d="M11.37 13.442l-.995-1.272"/></g>'
  },
  card: {
    width: 15,
    height: 15,
    content: '<path d="M9 5.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h5zm-.5 1h-4v4h4v-4zm2.5-3a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0V4.5H6a.5.5 0 0 1 0-1h5z" fill-rule="nonzero"/>'
  },
  podcast: {
    width: 15,
    height: 15,
    content: '<path d="M5.252 11.432A.5.5 0 0 1 4.5 11V4a.5.5 0 0 1 .752-.432l6 3.5a.5.5 0 0 1 0 .864l-6 3.5zm.248-1.303L10.008 7.5 5.5 4.87v5.26z" fill-rule="nonzero" />'
  },
  arrow: {
    width: 12,
    height: 12,
    content: '<path d="M3 7l3 3.5L9 7M6 10V1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" vector-effect="non-scaling-stroke" />'
  },
  brent: {
    width: 9,
    height: 12,
    content: '<g fill="#999" fill-rule="nonzero"><path d="M4.332 0l.528.606c2.528 2.902 3.804 5.07 3.804 6.634A4.332 4.332 0 110 7.24C0 5.676 1.276 3.508 3.804.606L4.332 0zm0 2.143l-.176.212C2.313 4.589 1.4 6.248 1.4 7.24a2.932 2.932 0 105.864 0c0-.992-.914-2.651-2.756-4.885l-.176-.212z"/><path d="M2.973 7.475c0 .415.417.863.835.924l.097.008v.7c-.79 0-1.548-.716-1.626-1.5l-.006-.132h.7z"/></g> '
  },
  user: {
    width: 16,
    height: 16,
    content: '<path fill="currentColor" fill-rule="nonzero" d="M8 1a4.25 4.25 0 012.676 7.552 6.751 6.751 0 014.074 6.198.75.75 0 11-1.5 0 5.25 5.25 0 00-10.5 0 .75.75 0 11-1.5 0 6.752 6.752 0 014.074-6.199A4.25 4.25 0 018 1zm0 1.5A2.75 2.75 0 108 8a2.75 2.75 0 000-5.5z" />'
  },
  bookmark: {
    width: 30,
    height: 30,
    content: '<g opacity="1"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 21.8237C24 22.847 24 23.3587 23.7885 23.6299C23.6043 23.8659 23.3242 24.007 23.025 24.0145C22.6811 24.0231 22.27 23.7185 21.4476 23.1094L15.9524 19.0388C15.6105 18.7856 15.4396 18.659 15.2523 18.6101C15.0869 18.567 14.9131 18.567 14.7477 18.6101C14.5604 18.659 14.3895 18.7856 14.0476 19.0388L8.55236 23.1094C7.73003 23.7185 7.31886 24.0231 6.97505 24.0145C6.67581 24.007 6.39566 23.8659 6.21155 23.6299C6 23.3587 6 22.847 6 21.8237V6.6C6 6.03995 6 5.75992 6.10899 5.54601C6.20487 5.35785 6.35785 5.20487 6.54601 5.10899C6.75992 5 7.03995 5 7.6 5H22.4C22.9601 5 23.2401 5 23.454 5.10899C23.6422 5.20487 23.7951 5.35785 23.891 5.54601C24 5.75992 24 6.03995 24 6.6V21.8237Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g>'
  },
  shareBookmark: {
    width: 11,
    height: 15,
    content: '<path clip-rule="evenodd" d="M10 14 5.5 9.667 1 14V1h9v13Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>'
  },
  receipt: {
    width: 10,
    height: 13,
    content: '<g fill="currentColor" fill-rule="nonzero"><path d="M10 0H0v13l2-1.74 1.5 1.305L5 11.26l1.5 1.305L8 11.26 10 13V0zM9 .997v9.81l-1-.87-1.5 1.304L5 9.937 3.5 11.24 2 9.937l-1 .87V.996h8z"/><path d="M7 3v1H3V3zM7 6v1H3V6z"/></g>'
  },
  read: {
    width: 15,
    height: 15,
    content: '<g fill="none" fill-rule="evenodd"><path opacity=".98" d="M0 0h15v15H0z"/><path d="M13.085 1.694a.513.513 0 01.855.56l-.051.077-3.163 3.975a.514.514 0 01-.73.075l-.068-.069-1.812-2.208a.512.512 0 01.729-.716l.065.066 1.409 1.718 2.766-3.478z" fill="#6EAC65" fill-rule="nonzero"/><path d="M6.454 12.997l-.06-.01-.078-.023a.49.49 0 01-.266-.24l.011.015a2.349 2.349 0 00-.535-.607c-.89-.745-2.117-.917-3.813-.12a.5.5 0 01-.706-.37L1 11.558V4.568a.5.5 0 01.287-.453c2.053-.963 3.695-.733 4.88.26.327.272.556.548.698.77l.084.144.018.04.022.076.01.071L7 11.233l.126-.09c.95-.656 2.16-.857 3.608-.417l.266.087v-2.81a.5.5 0 01.41-.491l.09-.008a.5.5 0 01.492.41l.008.09v3.555a.5.5 0 01-.713.452c-1.696-.796-2.922-.624-3.813.12a2.533 2.533 0 00-.497.544l-.038.064a.486.486 0 01-.485.258zm-4.29-8.17L2 4.892v5.92c1.637-.572 2.977-.348 4 .42l.002-5.58a2.605 2.605 0 00-.476-.513c-.81-.677-1.897-.88-3.362-.314z" fill="currentColor" fill-rule="nonzero"/></g>'
  },
  listened: {
    width: 15,
    height: 15,
    content: '<g fill-rule="nonzero"><path d="M4.978 4.354a.5.5 0 01-.332.624c-1.197.367-2.064 1.527-2.14 2.897l-.005.167a.749.749 0 01.999.708v3a.75.75 0 01-1.458.248L2 12a1 1 0 01-1-1v-1a1 1 0 01.5-.866V8.072c0-1.886 1.172-3.535 2.854-4.05a.5.5 0 01.624.332zM10 7a.5.5 0 01.492.41l.008.09.001 1.634a1 1 0 01.492.745L11 10v1a1 1 0 01-.883.993L10 12l-.042-.002a.75.75 0 01-1.451-.146L8.5 11.75v-3a.75.75 0 011.001-.707L9.5 7.5l.008-.09A.5.5 0 0110 7z" fill="currentColor" /><path d="M11.585 1.194a.513.513 0 01.855.56l-.051.077-3.163 3.975a.514.514 0 01-.73.075l-.068-.069-1.812-2.208a.512.512 0 01.729-.716l.065.066 1.409 1.718 2.766-3.478z" fill="#6EAC65" /></g>'
  },
  magic: {
    width: 15,
    height: 15,
    content: '<g fill-rule="evenodd" clip-rule="evenodd"> <path d="M7.804.4a.6.6 0 0 1 .6.6v2.035a.6.6 0 0 1-1.2 0V1a.6.6 0 0 1 .6-.6ZM7.804 10.577a.6.6 0 0 1 .6.6v2.035a.6.6 0 1 1-1.2 0v-2.035a.6.6 0 0 1 .6-.6ZM14.636 7.106a.6.6 0 0 1-.6.6h-2.078a.6.6 0 1 1 0-1.2h2.078a.6.6 0 0 1 .6.6ZM4.25 7.106a.6.6 0 0 1-.6.6H1.573a.6.6 0 0 1 0-1.2H3.65a.6.6 0 0 1 .6.6ZM12.639 2.37a.585.585 0 0 1 0 .84l-1.442 1.412a.615.615 0 0 1-.857 0 .585.585 0 0 1 0-.84l1.442-1.412a.615.615 0 0 1 .857 0ZM12.639 11.843a.615.615 0 0 1-.857 0L10.34 10.43a.585.585 0 0 1 0-.84.615.615 0 0 1 .857 0l1.442 1.413a.585.585 0 0 1 0 .84ZM5.269 4.621a.615.615 0 0 1-.858 0L2.97 3.208a.585.585 0 0 1 0-.84.615.615 0 0 1 .858 0l1.442 1.413a.585.585 0 0 1 0 .84ZM8.926 6.074a.6.6 0 0 1 0 .849l-.863.863-.849-.849.863-.863a.6.6 0 0 1 .849 0ZM7.348 8.5l-5.924 5.924a.6.6 0 1 1-.848-.848L6.5 7.652l.848.848Z"/> </g>'
  }
};
var styles$I = {
  "root": "SvgSymbol-module_root__WctNR",
  "small": "SvgSymbol-module_small__h9V-w",
  "normal": "SvgSymbol-module_normal__gFAVe",
  "medium": "SvgSymbol-module_medium__QaYjY",
  "large": "SvgSymbol-module_large__o6A4o",
  "adaptive": "SvgSymbol-module_adaptive__gL9qn",
  "fb": "SvgSymbol-module_fb__HZqcB",
  "vk": "SvgSymbol-module_vk__XctB2",
  "ok": "SvgSymbol-module_ok__IM6Z9",
  "tw": "SvgSymbol-module_tw__fio-Q",
  "tg": "SvgSymbol-module_tg__GRhd-",
  "magic": "SvgSymbol-module_magic__N-jKk",
  "reaction": "SvgSymbol-module_reaction__xSbgo",
  "card": "SvgSymbol-module_card__2nVFu",
  "podcast": "SvgSymbol-module_podcast__Yp05r",
  "read": "SvgSymbol-module_read__Bu653",
  "listened": "SvgSymbol-module_listened__AOn7j",
  "menu": "SvgSymbol-module_menu__z-dLm",
  "cross": "SvgSymbol-module_cross__3Xej1",
  "isInFeature": "SvgSymbol-module_isInFeature__BmyI-",
  "isInCard": "SvgSymbol-module_isInCard__USxBS",
  "isInTopicBlockItem": "SvgSymbol-module_isInTopicBlockItem__cnCgw",
  "isInPageStatic": "SvgSymbol-module_isInPageStatic__7kMP-",
  "isInMaterialMeta": "SvgSymbol-module_isInMaterialMeta__lIKJO",
  "isInAudioPlayer": "SvgSymbol-module_isInAudioPlayer__mamWa",
  "isInEpisodeBlock": "SvgSymbol-module_isInEpisodeBlock__oZ6JG",
  "isInButtonPlaybackRate": "SvgSymbol-module_isInButtonPlaybackRate__NnADm",
  "isInButtonBackward": "SvgSymbol-module_isInButtonBackward__x8L9a",
  "isInButtonForward": "SvgSymbol-module_isInButtonForward__TtixK",
  "isInToolbar": "SvgSymbol-module_isInToolbar__RzbaX",
  "play": "SvgSymbol-module_play__dAES0",
  "speedHalf": "SvgSymbol-module_speedHalf__mvVYC",
  "speedThreeQuarters": "SvgSymbol-module_speedThreeQuarters__9N7uH",
  "speedOne": "SvgSymbol-module_speedOne__sRNph",
  "speedOneQuarter": "SvgSymbol-module_speedOneQuarter__fKIT7",
  "speedOneHalf": "SvgSymbol-module_speedOneHalf__7yXsa",
  "speedTwo": "SvgSymbol-module_speedTwo__Bv8-b",
  "meduzaLogo": "SvgSymbol-module_meduzaLogo__aVKzZ",
  "arrow": "SvgSymbol-module_arrow__lWTSJ",
  "oil": "SvgSymbol-module_oil__VFGTp",
  "search": "SvgSymbol-module_search__h06cc",
  "user": "SvgSymbol-module_user__ORMm-",
  "bookmark": "SvgSymbol-module_bookmark__JPKyG",
  "shareBookmark": "SvgSymbol-module_shareBookmark__7w9X9",
  "receipt": "SvgSymbol-module_receipt__o3V8u",
  "isInHeader": "SvgSymbol-module_isInHeader__M5Tzw"
};
const SvgSymbol = _ref4 => {
  let {
    icon,
    size,
    styleContext
  } = _ref4;
  const data = icons[icon];
  return /*#__PURE__*/React.createElement("svg", {
    "data-testid": "svg-symbol",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: makeClassName([[styles$I.root, true], [styles$I[size], !!styles$I[size]], [styles$I[icon], !!styles$I[icon]], [styles$I[styleContext], !!styles$I[styleContext]]]),
    width: data.width,
    height: data.height,
    viewBox: `0 0 ${data.width} ${data.height}`,
    dangerouslySetInnerHTML: {
      __html: data.content
    }
  });
};
var styles$H = {
  "root": "Switcher-module_root__cBsJB",
  "dark": "Switcher-module_dark__1QQsH",
  "control": "Switcher-module_control__60WMX",
  "input": "Switcher-module_input__5UDnv",
  "knob": "Switcher-module_knob__PwA1A",
  "isInMenu": "Switcher-module_isInMenu__RQVhp",
  "isInLive": "Switcher-module_isInLive__ZyMCT",
  "children": "Switcher-module_children__uLapU"
};
const Switcher = _ref5 => {
  let {
    enabled,
    onChange,
    styleContext,
    theme = 'light',
    childrenLeft,
    childrenRight
  } = _ref5;
  return /*#__PURE__*/React.createElement("label", {
    "data-testid": "switcher",
    className: makeClassName([[styles$H.root, true], [styles$H[theme], !!styles$H[theme]], [styles$H[styleContext], !!styles$H[styleContext]]])
  }, childrenLeft && (/*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$H.children, true], [styles$H.left, true]])
  }, childrenLeft)), /*#__PURE__*/React.createElement("input", {
    className: styles$H.input,
    type: "checkbox",
    checked: enabled,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$H.control
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$H.knob
  })), childrenRight && (/*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$H.children, true], [styles$H.right, true]])
  }, childrenRight)));
};
const makeStyleContext = (classNames, styleContext, styles) => {
  const context = Array.isArray(styleContext) ? styleContext.filter(ctx => styles[ctx]).map(ctx => [[styles[ctx]], true]) : [[styles[styleContext], !!styleContext && !!styles[styleContext]]];
  return classNames.concat(context);
};
const BlockContext = /*#__PURE__*/React.createContext({
  lightBox: null
});
const BlockProvider = BlockContext.Provider;
const POST_MESSAGE_PREFIX = 'mdzKitMsg';
const postMessage = (category, element, action) => {
  const target = window.top;
  const msg = `${POST_MESSAGE_PREFIX}=${JSON.stringify({
    category,
    element,
    action
  })}`;
  if (typeof target !== 'undefined') {
    target.postMessage(msg, '*');
  }
};
var styles$G = {
  "root": "Lazy-module_root__DWw8D"
};
const Lazy = _ref6 => {
  let {
    children,
    threshold
  } = _ref6;
  const [ref, inView, entry] = useInView({
    threshold: threshold || 0
  });
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (entry && entry.boundingClientRect && entry.boundingClientRect.y < 0) {
      setVisible(true);
    }
  }, [entry]);
  useEffect(() => {
    if (inView) {
      setVisible(true);
    }
  }, [inView]);
  return /*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$G.root, true], [styles$G.visible, visible]]),
    ref: ref,
    "data-testid": "lazy"
  }, visible && children);
};
const MediaQuerySizes = {
  MOBILE: 512,
  PORTRAIT_TABLET: 768,
  LANDSCAPE_TABLET: 1024,
  DESKTOP: 1010,
  WIDE_DESKTOP: 1200
};
const imageBreakpoints = {
  325: '(min-width: 0)',
  520: '(min-width: 325px)',
  600: '(min-width: 600px)',
  650: '(min-width: 650px)',
  980: '(min-width: 1000px)',
  1335: '(min-width: 1000px)'
};
const imageConditionalKeys = {
  xs: [325],
  superFull: [1335, 650, 520, 325],
  full: [980, 650, 520, 325],
  default: [650, 520, 325],
  narrow: [600, 325]
};
const SocialLabels = {
  ru: {
    tg: 'Телеграм',
    fb: 'Фейсбук',
    tw: 'Твиттер',
    pdf: 'PDF',
    unblock: 'Magic link',
    bookmark: 'В закладки',
    reaction: 'Напишите нам'
  },
  en: {
    tg: 'Telegram',
    fb: 'Fb',
    tw: 'Twitter',
    pdf: 'PDF',
    unblock: 'Magic link',
    bookmark: 'Add to bookmarks'
  }
};
const toCamel = s => s.replace(/([_][a-z])/gi, str => str.toUpperCase().replace('_', ''));
const toCapitalize = s => s[0].toUpperCase() + s.slice(1);
const RenderPicture = _ref7 => {
  let {
    source,
    fallbackSource,
    optimized,
    alt,
    display,
    onLoad
  } = _ref7;
  const [fallback, setFallback] = useState(false);
  useEffect(() => {
    setFallback(!window.HTMLPictureElement);
  }, []);
  const keys = imageConditionalKeys[toCamel(display)] || imageConditionalKeys.default;
  return /*#__PURE__*/React.createElement("picture", null, source && (/*#__PURE__*/React.createElement("source", {
    media: "(min-width: 325px)",
    srcSet: `${source[1]} 2x`
  })), optimized && !optimized.w325 && (/*#__PURE__*/React.createElement("source", {
    media: "(min-width: 0)",
    srcSet: `${optimized.original}`
  })), optimized && keys.map(key => {
    const breakpoint = optimized[`w${key}`];
    if (!breakpoint) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement("source", {
      type: "image/webp",
      media: imageBreakpoints[key],
      srcSet: `${breakpoint['2x_webp']} 2x, ${breakpoint['1x_webp']} 1x `
    }), /*#__PURE__*/React.createElement("source", {
      type: "image/png",
      media: imageBreakpoints[key],
      srcSet: `${breakpoint['2x']} 2x, ${breakpoint['1x']} 1x `
    }));
  }), /*#__PURE__*/React.createElement("img", {
    src: fallback ? fallbackSource : 'data:image/gif;base64,R0lGODlhAQABAPAAAPLy8gAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==',
    alt: alt,
    onLoad: () => onLoad(true)
  }));
};
var styles$F = {
  "root": "Image-module_root__H5wAh",
  "fullRatio": "Image-module_fullRatio__q7QPa",
  "isStatic": "Image-module_isStatic__TmQ1V",
  "isLoaded": "Image-module_isLoaded__keFnD",
  "wrapper": "Image-module_wrapper__gJtbB",
  "fullscreen": "Image-module_fullscreen__4PU9c",
  "dark": "Image-module_dark__qjo5O"
};
const Image = _ref8 => {
  let {
    alt,
    display,
    optimized,
    width,
    height,
    source,
    lazy,
    ratio,
    styleContext,
    fullscreen = true
  } = _ref8;
  const {
    lightBox
  } = useContext(BlockContext);
  const [isLoaded, setIsLoaded] = useState(lazy ? false : true);
  const handleClick = () => {
    if (!lightBox || !fullscreen || optimized && !optimized.original) {
      return;
    }
    postMessage('', 'fullscreen_click', 'click');
    lightBox.show(optimized, width, height, alt);
  };
  const blockStyles = {
    maxWidth: width <= 649 ? width : '100%'
  };
  const pictureStyles = {
    paddingBottom: ratio === null ? 'unset' : `${100 / (ratio || width / height)}%`
  };
  /* fallback w325 url until w6 was released */
  const fallbackSource = source && source[0] || optimized.w325 && optimized.w325['1x'] || optimized.original;
  let classNames = [[styles$F.root, true], [styles$F.isLoaded, isLoaded], [styles$F.fullscreen, lightBox && optimized && optimized.original && fullscreen], [styles$F.fullRatio, ratio === null]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$F);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: makeClassName(classNames),
    style: blockStyles,
    "data-testid": "image"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$F.wrapper,
    style: pictureStyles,
    onClick: () => handleClick(),
    onKeyPress: () => handleClick(),
    role: "button",
    tabIndex: 0
  }, lazy ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Lazy, {
    threshold: 0.25
  }, /*#__PURE__*/React.createElement(RenderPicture, {
    fallbackSource: fallbackSource,
    source: source,
    optimized: optimized,
    alt: alt,
    display: display,
    onLoad: setIsLoaded
  })), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("img", {
    src: fallbackSource,
    alt: alt
  })))) : (/*#__PURE__*/React.createElement(RenderPicture, {
    fallbackSource: fallbackSource,
    source: source,
    optimized: optimized,
    alt: alt,
    display: display,
    onLoad: setIsLoaded
  }))));
};
var styles$E = {
  "root": "Popover-module_root__nBiV4",
  "fadeOut": "Popover-module_fadeOut__Y88V7",
  "visible": "Popover-module_visible__XVQLW",
  "fadeIn": "Popover-module_fadeIn__FK1gd",
  "overlay": "Popover-module_overlay__NAPar",
  "container": "Popover-module_container__y4SB1",
  "disappear": "Popover-module_disappear__uUn2b",
  "dismiss": "Popover-module_dismiss__W8KFF",
  "background": "Popover-module_background__apiio",
  "appear": "Popover-module_appear__b-CZ2",
  "body": "Popover-module_body__UJEZf"
};
const Popover = _ref9 => {
  let {
    children,
    onClose
  } = _ref9;
  const [visible, setVisible] = useState(true);
  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 350);
  };
  const handleScroll = () => {
    handleClose();
  };
  const escFunction = event => {
    if (event.key === 'Escape') {
      handleClose();
    }
  };
  useEffect(() => {
    document.body.dataset.popover = 'true';
    window.addEventListener('keydown', escFunction, false);
    window.addEventListener('scroll', handleScroll, false);
    return () => {
      document.body.removeAttribute('data-popover');
      window.removeEventListener('keydown', escFunction, false);
      window.removeEventListener('scroll', handleScroll, false);
    };
  }, [visible]);
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "popover",
    className: makeClassName([[styles$E.root, true], [styles$E.visible, visible]])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$E.overlay,
    onClick: () => handleClose()
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$E.container
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles$E.dismiss,
    onClick: () => handleClose(),
    "aria-label": "dismiss"
  }), /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    className: styles$E.background
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "myMask",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: "0",
    width: "100%",
    height: "100%",
    x: "0"
  }), /*#__PURE__*/React.createElement("svg", {
    x: "50%",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61852778e-14,9.76996262e-15 L9.84597532,5.80270273 C11.0992017,6.54128882 12.6546044,6.54128882 13.9078308,5.80270273 L23.7538061,9.76996262e-15 L4.61852778e-14,9.76996262e-15 Z"
  }))))), /*#__PURE__*/React.createElement("rect", {
    fill: "#F7F7F7",
    id: "base-mask",
    mask: "url(#myMask)",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$E.body
  }, children)));
};
var styles$D = {
  "root": "Footnote-module_root__W5D8G",
  "body": "Footnote-module_body__C-ZC-",
  "dismiss": "Footnote-module_dismiss__Q2hAX"
};
const Footnote = _ref10 => {
  let {
    children,
    onClose
  } = _ref10;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "footnote",
    className: makeClassName([[styles$D.root, true]])
  }, /*#__PURE__*/React.createElement("button", {
    className: styles$D.dismiss,
    type: "button",
    onClick: () => onClose()
  }, /*#__PURE__*/React.createElement(SvgSymbol, {
    icon: "cross",
    size: "unset"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$D.body
  }, children));
};
var viewportSize = () => ({
  width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
  height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
});
var styles$C = {
  "root": "DotsOnImage-module_root__8UQf2",
  "isVisible": "DotsOnImage-module_isVisible__rA5x9",
  "marker": "DotsOnImage-module_marker__pLdQT",
  "show": "DotsOnImage-module_show__Ec0lG",
  "dot": "DotsOnImage-module_dot__e2MWx",
  "isActive": "DotsOnImage-module_isActive__Bhb58",
  "popover": "DotsOnImage-module_popover__zHSbU",
  "isRight": "DotsOnImage-module_isRight__IaUbc",
  "isTop": "DotsOnImage-module_isTop__RMK49",
  "isLeft": "DotsOnImage-module_isLeft__Q6JZ-",
  "isBottom": "DotsOnImage-module_isBottom__c-aLe"
};
const DotsOnImage = _ref11 => {
  let {
    block: {
      optimized,
      width,
      height,
      credit,
      display,
      dots
    }
  } = _ref11;
  const [ratio, setRatio] = useState(1);
  const [ref, inView, entry] = useInView();
  const container = useRef(null);
  const [popover, setPopover] = useState({
    title: null,
    body: null,
    show: false,
    id: null
  });
  const [visible, setVisible] = useState(false);
  const defaultWidth = 375;
  useEffect(() => {
    if (entry && entry.boundingClientRect && entry.boundingClientRect.y < 0) {
      setVisible(true);
    }
  }, [entry]);
  useEffect(() => {
    if (inView) {
      setVisible(true);
    }
  }, [inView]);
  useEffect(() => {
    if (popover.id) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => document.removeEventListener('click', handleClickOutside);
  }, [popover]);
  useEffect(() => {
    setDotSize();
    window.addEventListener('resize', setDotSize);
    return () => document.removeEventListener('resize', setDotSize);
  }, [visible]);
  const setDotSize = () => {
    const width = window.innerWidth;
    if (width < defaultWidth) {
      const ratio = width / defaultWidth;
      setRatio(ratio);
    } else {
      setRatio(1);
    }
  };
  const handleClickOutside = event => {
    const path = event.composedPath();
    if (path.indexOf(container.current) === -1) {
      setPopover({
        show: false
      });
    }
  };
  const handleDotClick = dot => {
    const shouldShow = dot.id !== popover.id;
    const side = dot.position.x > 50 ? 'isLeft' : 'isRight';
    const align = dot.position.y > 50 ? 'isBottom' : 'isTop';
    const style = {
      top: `${dot.position.y}%`,
      left: `${dot.position.x}%`
    };
    setPopover({
      title: dot.title,
      body: dot.body,
      show: shouldShow,
      id: shouldShow ? dot.id : null,
      style,
      side,
      align
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$C.root, true], [styles$C.isVisible, visible]]),
    "data-testid": "dots-on-image",
    ref: ref
  }, /*#__PURE__*/React.createElement(Image, {
    fullscreen: false,
    optimized: optimized,
    width: width,
    height: height,
    alt: credit,
    display: display
  }), /*#__PURE__*/React.createElement("div", {
    ref: container
  }, dots.map(dot => (/*#__PURE__*/React.createElement("div", {
    className: styles$C.dot,
    key: dot.id,
    style: {
      top: `${dot.position.y}%`,
      left: `${dot.position.x}%`,
      transform: `scale(${ratio}) translate(-${50 / ratio}%, -${50 / ratio}%)`
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: makeClassName([[styles$C.marker, true], [styles$C.isActive, dot.id === popover.id]]),
    type: "button",
    style: {
      backgroundColor: dot.icon.color
    },
    onClick: () => handleDotClick(dot)
  }, dot.icon.type === 'svg' && (/*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dot.icon.svg_string
    }
  })), dot.icon.type === 'number' && dot.icon.number)))), popover.show && (/*#__PURE__*/React.createElement(React.Fragment, null, viewportSize().width >= MediaQuerySizes.LANDSCAPE_TABLET ? (/*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$C.popover, true], [styles$C[popover.side], !!popover.side], [styles$C[popover.align], !!popover.align]]),
    style: popover.style
  }, /*#__PURE__*/React.createElement(Footnote, {
    onClose: () => {
      setPopover({
        show: false
      });
    }
  }, popover.title && /*#__PURE__*/React.createElement("h3", null, popover.title), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: popover.body
    }
  })))) : (/*#__PURE__*/React.createElement(Popover, {
    onClose: () => {
      setPopover({
        show: false
      });
    }
  }, popover.title && /*#__PURE__*/React.createElement("h3", null, popover.title), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: popover.body
    }
  })))))));
};
var styles$B = {
  "root": "Tag-module_root__sGbnM",
  "small": "Tag-module_small__hcPrf",
  "large": "Tag-module_large__EKMu6",
  "dark": "Tag-module_dark__9SHCb",
  "light": "Tag-module_light__qlfy3",
  "gold": "Tag-module_gold__u0bzS",
  "gray": "Tag-module_gray__eazPk",
  "inherit": "Tag-module_inherit__z21c-",
  "is1to1": "Tag-module_is1to1__V-fH5",
  "is1to2": "Tag-module_is1to2__b9Obh",
  "isInSuperBlock": "Tag-module_isInSuperBlock__wrFUY",
  "is1to3": "Tag-module_is1to3__vZT-R",
  "is1to4": "Tag-module_is1to4__MBh5V",
  "slide": "Tag-module_slide__gzptP",
  "game": "Tag-module_game__NmKec",
  "podcastMaterial": "Tag-module_podcastMaterial__O-LBI",
  "richRelated": "Tag-module_richRelated__Qs6Ei",
  "isInBookRelated": "Tag-module_isInBookRelated__ikTaj",
  "card": "Tag-module_card__TX87-",
  "live": "Tag-module_live__ykyR7",
  "episode": "Tag-module_episode__3OHmN",
  "podcast": "Tag-module_podcast__K6dHn",
  "rich": "Tag-module_rich__vPnWd",
  "isInDynamicBlock": "Tag-module_isInDynamicBlock__WNleF",
  "isInPodcastPlayer": "Tag-module_isInPodcastPlayer__H4sK9",
  "mobile": "Tag-module_mobile__19oMH",
  "desktop": "Tag-module_desktop__cNyQs"
};
const Tag = _ref12 => {
  let {
    children,
    size = 'small',
    theme = 'gold',
    styleContext,
    correlation,
    onlyOn
  } = _ref12;
  let classNames = [[styles$B.root, true], [styles$B[size], !!size && !!styles$B[size]], [styles$B[theme], !!theme && !!styles$B[theme]], [styles$B[onlyOn], !!onlyOn && !!styles$B[onlyOn]], [styles$B[correlation], !!correlation && !!styles$B[correlation]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$B);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "tag",
    className: makeClassName(classNames)
  }, children);
};
var styles$A = {
  "root": "MediaCaption-module_root__1r0wu",
  "caption": "MediaCaption-module_caption__ewfcc",
  "credit": "MediaCaption-module_credit__7y4v8",
  "dark": "MediaCaption-module_dark__7a9Cm",
  "video": "MediaCaption-module_video__RDTUa",
  "picture": "MediaCaption-module_picture__abCvw",
  "desktop": "MediaCaption-module_desktop__e0lCY",
  "isDark": "MediaCaption-module_isDark__IFb9X"
};
const MediaCaption = _ref13 => {
  let {
    credit,
    caption,
    styleContext
  } = _ref13;
  let classNames = [[styles$A.root, true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$A);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "media-caption",
    className: makeClassName(classNames)
  }, caption && (/*#__PURE__*/React.createElement("div", {
    className: styles$A.caption,
    dangerouslySetInnerHTML: {
      __html: caption
    }
  })), credit && (/*#__PURE__*/React.createElement("div", {
    className: styles$A.credit,
    dangerouslySetInnerHTML: {
      __html: credit
    }
  })));
};
var styles$z = {
  "root": "Table-module_root__fRuZq",
  "card": "Table-module_card__8r-EA",
  "table": "Table-module_table__7Pagp",
  "slide": "Table-module_slide__dgMPV",
  "wrapper": "Table-module_wrapper__AP4Pz",
  "tracks": "Table-module_tracks__mRNG0",
  "default": "Table-module_default__nwBEg",
  "full": "Table-module_full__YZPDz",
  "row": "Table-module_row__9OHT3",
  "cell": "Table-module_cell__yFdqc",
  "fixedColumn": "Table-module_fixedColumn__O2528",
  "white": "Table-module_white__Laj3-",
  "gray": "Table-module_gray__FPFh0",
  "pink": "Table-module_pink__CGkAA",
  "blue": "Table-module_blue__b8BHs",
  "yellow": "Table-module_yellow__YOJgu",
  "orange": "Table-module_orange__B-i8L",
  "green": "Table-module_green__Bt6iC",
  "violet": "Table-module_violet__yTZd7",
  "header": "Table-module_header__YPDzO",
  "s": "Table-module_s__I-CeX",
  "m": "Table-module_m__vxhDf",
  "l": "Table-module_l__GYHhk",
  "xs": "Table-module_xs__imR8t"
};
const Table = _ref14 => {
  let {
    styleContext,
    block: {
      rows,
      options,
      display,
      columns_widths: columnsWidth,
      table_credit: tableCredit
    }
  } = _ref14;
  const colors = {
    '#ffffff': 'white',
    '#f5f5f5': 'gray',
    '#feeeee': 'pink',
    '#e6f3ff': 'blue',
    '#fffde6': 'yellow',
    '#fff9f2': 'orange',
    '#e7f2ef': 'green',
    '#f4f0f8': 'violet'
  };
  let classNames = [[styles$z.root, true], [styles$z[display], !!display && !!styles$z[display]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$z);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "table",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$z.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$z.table
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$z.tracks
  }, rows.map((row, i) => {
    return /*#__PURE__*/React.createElement("div", {
      key: row.key,
      className: styles$z.row
    }, row.cells.map((cell, j) => (/*#__PURE__*/React.createElement("div", {
      key: cell.key,
      className: makeClassName([[styles$z.cell, true], [styles$z.header, options.header && i === 0], [styles$z[colors[cell.color]], true], [styles$z[columnsWidth[j]], true], [styles$z.fixedColumn, options.fixed_first_column && j === 0]]),
      dangerouslySetInnerHTML: {
        __html: cell.val
      }
    }))));
  })))), tableCredit && (/*#__PURE__*/React.createElement(MediaCaption, {
    credit: tableCredit,
    styleContext: styleContext
  })));
};
var styles$y = {
  "root": "MaterialNote-module_root__99HSA",
  "dark": "MaterialNote-module_dark__etjym",
  "note_credit": "MaterialNote-module_note_credit__J1skG",
  "note_caption": "MaterialNote-module_note_caption__G2Ad0",
  "center": "MaterialNote-module_center__mDLEO",
  "default": "MaterialNote-module_default__ozgd7",
  "card": "MaterialNote-module_card__EVuZe",
  "slide": "MaterialNote-module_slide__mg8XV",
  "game": "MaterialNote-module_game__c-r0n",
  "gameSurvey": "MaterialNote-module_gameSurvey__azhu6"
};
const MaterialNote = _ref15 => {
  let {
    block: {
      data
    },
    styleContext
  } = _ref15;
  let classNames = [[styles$y.root, true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$y);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "material-note",
    className: makeClassName(classNames)
  }, data && data.map(item => (/*#__PURE__*/React.createElement("p", {
    className: styles$y[item.type],
    key: item.id,
    dangerouslySetInnerHTML: {
      __html: item.data
    }
  })))));
};
var styles$x = {
  "root": "BookmarkButton-module_root__A-75w",
  "control": "BookmarkButton-module_control__-xy5O",
  "dark": "BookmarkButton-module_dark__GkMEC",
  "light": "BookmarkButton-module_light__1W6tx",
  "isInBookmarks": "BookmarkButton-module_isInBookmarks__YSjjj",
  "isInGrid": "BookmarkButton-module_isInGrid__Desh-"
};
const BookmarkButton = _ref16 => {
  let {
    styleContext,
    theme,
    isInBookmarks,
    onClick
  } = _ref16;
  let classNames = [[styles$x.root, true], [styles$x.isInBookmarks, isInBookmarks], [styles$x[theme], !!theme && !!styles$x[theme]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$x);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "bookmark-button",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("button", {
    className: styles$x.control,
    onClick: () => onClick(),
    type: "button"
  }, /*#__PURE__*/React.createElement(SvgSymbol, {
    icon: "bookmark",
    size: "unset"
  })));
};
var styles$w = {
  "root": "MaterialTitle-module_root__VSphO",
  "primary": "MaterialTitle-module_primary__XGnpb",
  "secondary": "MaterialTitle-module_secondary__7IDEp"
};
const Primary = _ref17 => {
  let {
    children
  } = _ref17;
  return /*#__PURE__*/React.createElement("span", {
    className: styles$w.primary
  }, children);
};
const Secondary = _ref18 => {
  let {
    children
  } = _ref18;
  return /*#__PURE__*/React.createElement("span", {
    className: styles$w.secondary
  }, children);
};
const MaterialTitle = _ref19 => {
  let {
    children
  } = _ref19;
  return /*#__PURE__*/React.createElement("h1", {
    className: styles$w.root,
    "data-testid": "material-title"
  }, children);
};
var styles$v = {
  "root": "Dropdown-module_root__Wv7S-",
  "menu": "Dropdown-module_menu__11IQL",
  "inactive": "Dropdown-module_inactive__E5CP6",
  "isInAudioPanel": "Dropdown-module_isInAudioPanel__UniSV"
};
const Menu = _ref20 => {
  let {
    children
  } = _ref20;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "dropdown",
    className: styles$v.menu
  }, children);
};
const Dropdown = _ref21 => {
  let {
    children,
    active,
    styleContext
  } = _ref21;
  let classNames = [[styles$v.root, true], [styles$v.inactive, !active && styleContext === 'isPodcastSeason' && !!styles$v.inactive]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$v);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "dropdown",
    className: makeClassName(classNames)
  }, children);
};
var styles$u = {
  "root": "Toolbar-module_root__RnmlI",
  "list": "Toolbar-module_list__-IhdP",
  "item": "Toolbar-module_item__CWmGM",
  "isInTopbar": "Toolbar-module_isInTopbar__WEDi8",
  "center": "Toolbar-module_center__pvdiJ",
  "game": "Toolbar-module_game__etwIA",
  "gameSurvey": "Toolbar-module_gameSurvey__v4D31",
  "slide": "Toolbar-module_slide__PtB3l",
  "card": "Toolbar-module_card__Lutyq",
  "isDark": "Toolbar-module_isDark__MG6Ar",
  "dark": "Toolbar-module_dark__a9sgz",
  "podcast": "Toolbar-module_podcast__ahY4M"
};
const ToolbarItem = _ref22 => {
  let {
    children
  } = _ref22;
  return /*#__PURE__*/React.createElement("li", {
    className: styles$u.item
  }, children);
};
const Toolbar = _ref23 => {
  let {
    children,
    styleContext
  } = _ref23;
  let classNames = [[styles$u.root, true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$u);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "toolbar",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles$u.list
  }, children));
};
var styles$t = {
  "root": "Meta-module_root__H-Q4d",
  "rich": "Meta-module_rich__dCkJK",
  "podcast": "Meta-module_podcast__MI8gD",
  "episode": "Meta-module_episode__0n9CF",
  "simple": "Meta-module_simple__tztcr",
  "slide": "Meta-module_slide__3OyIN",
  "card": "Meta-module_card__2vqfN",
  "game": "Meta-module_game__HNcgr",
  "isInMaterial": "Meta-module_isInMaterial__vKcTK",
  "isInSearchItem": "Meta-module_isInSearchItem__ENqHo",
  "isInMediaBlock": "Meta-module_isInMediaBlock__TENZG",
  "center": "Meta-module_center__seHro",
  "half": "Meta-module_half__aoa9h",
  "podcastMaterial": "Meta-module_podcastMaterial__GTPyD",
  "light": "Meta-module_light__oW3kc",
  "dark": "Meta-module_dark__tLQNJ",
  "isDark": "Meta-module_isDark__xSl1J",
  "hasSource": "Meta-module_hasSource__OZJ0y",
  "bookmark": "Meta-module_bookmark__jcFWn",
  "isInBookRelated": "Meta-module_isInBookRelated__Ohidg",
  "mobile": "Meta-module_mobile__PbG8N",
  "desktop": "Meta-module_desktop__W5AB7"
};
const Meta = _ref24 => {
  let {
    hasSource,
    theme,
    children,
    onlyOn,
    styleContext
  } = _ref24;
  let classNames = [[styles$t.root, true], [styles$t[theme], !!theme && !!styles$t[theme]], [styles$t[onlyOn], !!onlyOn], [styles$t.hasSource, hasSource]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$t);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "meta",
    className: makeClassName(classNames)
  }, children);
};
var styles$s = {
  "root": "Timestamp-module_root__jPJ6w"
};
const Timestamp = _ref25 => {
  let {
    publishedAt,
    locale = 'ru',
    type
  } = _ref25;
  let published;
  const timeFormat = locale === 'ru' ? 'HH:mm, D MMMM YYYY' : 'h:mm a, MMMM D, YYYY';
  const preparedPublishedAt = publishedAt * 1000;
  dayjs.locale(locale);
  dayjs.extend(relativeTime);
  if (type === 'fromNow') {
    published = dayjs(preparedPublishedAt).fromNow();
  } else if (type === 'format') {
    published = dayjs(preparedPublishedAt).format('HH:mm');
  } else if (type === 'date') {
    published = dayjs(preparedPublishedAt).format(timeFormat);
  } else {
    throw new Error('Unknown time type');
  }
  return /*#__PURE__*/React.createElement("time", {
    suppressHydrationWarning: true,
    "data-testid": "timestamp",
    className: styles$s.root
  }, published);
};
const DangerousHTML = _ref26 => {
  let {
    className = '',
    tagName: TagName = 'div',
    html
  } = _ref26;
  const element = useRef(null);
  const [canRenderHtml, setCanRenderHtml] = useState(false);
  useEffect(() => {
    setCanRenderHtml(true);
  }, []);
  const replaceScriptElementsRecursive = useCallback(node => {
    if (node.tagName === 'SCRIPT' && (!node.id || node.id.indexOf('script-') !== 0)) {
      const script = document.createElement('script');
      script.id = `script-${Math.random().toString(16).slice(2)}`;
      script.innerHTML = node.innerHTML;
      const attrs = node.attributes;
      for (let i = 0; i < attrs.length; i += 1) {
        const {
          name,
          value
        } = attrs[i];
        script.setAttribute(name, value);
      }
      node.parentElement.replaceChild(script, node);
    } else {
      let i = 0;
      const children = node.childNodes;
      while (i < children.length) {
        replaceScriptElementsRecursive(children[i]);
        i += 1;
      }
    }
  }, []);
  const prepareAnchors = useCallback(() => {
    const anchors = Array.from(element.current.querySelectorAll('a'));
    anchors.forEach(a => {
      a.setAttribute('target', '_blank');
    });
  }, []);
  useEffect(() => {
    if (canRenderHtml && html.indexOf('script') > -1 && element.current.firstElementChild) {
      element.current.firstElementChild.innerHTML = html;
      replaceScriptElementsRecursive(element.current.firstElementChild);
      prepareAnchors();
    }
  }, [canRenderHtml, element, html, replaceScriptElementsRecursive, prepareAnchors]);
  return /*#__PURE__*/React.createElement("div", {
    ref: element
  }, /*#__PURE__*/React.createElement(TagName, {
    className: className,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
};
var styles$r = {
  "root": "EmbedBlock-module_root__wNZlD",
  "object": "EmbedBlock-module_object__DONQ0",
  "objectWrap": "EmbedBlock-module_objectWrap__qpbni",
  "gameEmbed": "EmbedBlock-module_gameEmbed__tO5Ha",
  "proportional": "EmbedBlock-module_proportional__zDPfm",
  "default": "EmbedBlock-module_default__np8MO",
  "xs": "EmbedBlock-module_xs__PNHGz",
  "full": "EmbedBlock-module_full__Gmz7o",
  "super_full": "EmbedBlock-module_super_full__-h382",
  "figure": "EmbedBlock-module_figure__fNZB-",
  "dark": "EmbedBlock-module_dark__S2R9f",
  "isInGroupedBlock": "EmbedBlock-module_isInGroupedBlock__Wjj7k",
  "control": "EmbedBlock-module_control__9bJUa",
  "raw_html": "EmbedBlock-module_raw_html__EfYVy",
  "mobileFullwidth": "EmbedBlock-module_mobileFullwidth__1MDT5",
  "isInCard": "EmbedBlock-module_isInCard__WnLHG",
  "isInSlide": "EmbedBlock-module_isInSlide__BtdnY",
  "cc": "EmbedBlock-module_cc__Gyw44",
  "isInSensitiveBlock": "EmbedBlock-module_isInSensitiveBlock__nYajZ",
  "isInAnswer": "EmbedBlock-module_isInAnswer__WuZ0H",
  "picture": "EmbedBlock-module_picture__Weamy",
  "wrapper": "EmbedBlock-module_wrapper__ynT7R",
  "isProportional": "EmbedBlock-module_isProportional__x8-8g",
  "mobile": "EmbedBlock-module_mobile__lEuww",
  "desktop": "EmbedBlock-module_desktop__599S7"
};
const EmbedGif = _ref27 => {
  let {
    gif,
    mp4Url,
    style
  } = _ref27;
  const [videoFrozen, setVideoFrozen] = useState(false);
  const videoElem = useRef(null);
  const handleVideoTouch = () => {
    videoElem.current.play();
    setVideoFrozen(false);
  };
  const handleVideoError = () => {
    const video = videoElem.current;
    video.setAttribute('poster', video.dataset.gif);
    setVideoFrozen(false);
  };
  useEffect(() => {
    const video = videoElem.current;
    const {
      width: viewportWidth
    } = viewportSize();
    if (viewportWidth >= MediaQuerySizes.MOBILE) {
      video.setAttribute('autoplay', true);
      video.play();
    } else {
      setVideoFrozen(true);
      video.pause();
      video.addEventListener('touchstart', handleVideoTouch);
    }
    video.addEventListener('error', handleVideoError);
    return () => {
      video.removeEventListener('touchstart', handleVideoTouch);
      video.removeEventListener('error', handleVideoError);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$r.figure
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$r.objectWrap,
    style: style,
    "data-frozen": videoFrozen
  }, /*#__PURE__*/React.createElement("video", {
    playsInline: true,
    muted: true,
    loop: true,
    autoPlay: true,
    preload: "metadata",
    "data-gif": gif,
    ref: videoElem
  }, /*#__PURE__*/React.createElement("source", {
    src: `https://meduza.io${mp4Url}`,
    type: "video/mp4"
  }))));
};
const EmbedBlock = _ref28 => {
  let {
    block,
    block: {
      data,
      data: {
        html,
        display,
        only_on: onlyOn,
        provider,
        cc,
        optimized,
        small_url: small,
        large_url: large,
        gif_url: gifUrl,
        mp4_url: mp4Url
      }
    },
    styleContext,
    children
  } = _ref28;
  const [isPopoverShown, setIsPopoverShown] = useState(false);
  const style = {};
  const isProportional = block.data.height && block.data.width;
  const fullWidthProviders = ['youtube', 'vimeo', 'onetv', 'coub', 'meduza', 'facebook_video'];
  const mobileFullwidth = fullWidthProviders.indexOf(provider) > -1 || block.type === 'dots_on_image';
  const renderCC = context => (/*#__PURE__*/React.createElement(MediaCaption, {
    credit: data.credit,
    caption: data.caption,
    styleContext: context || styleContext
  }));
  const renderEmbed = style => {
    switch (block.type) {
      case 'gif':
        {
          return /*#__PURE__*/React.createElement(EmbedGif, {
            gif: gifUrl,
            mp4Url: mp4Url,
            style: style
          });
        }
      case 'image':
        {
          return /*#__PURE__*/React.createElement("div", {
            className: styles$r.figure
          }, /*#__PURE__*/React.createElement(Image, {
            source: !optimized && [small, large],
            optimized: block.data.optimized,
            width: block.data.width,
            height: block.data.height,
            alt: block.data.caption,
            display: block.data.display,
            lazy: block.data.lazy,
            styleContext: styleContext
          }));
        }
      case 'game_embed':
        {
          return /*#__PURE__*/React.createElement("div", {
            className: styles$r.gameEmbed
          }, /*#__PURE__*/React.createElement("iframe", {
            src: block.data.game_src,
            id: block.data.game_id,
            title: "Game embed"
          }));
        }
      case 'dots_on_image':
        {
          return /*#__PURE__*/React.createElement("div", {
            className: styles$r.figure
          }, /*#__PURE__*/React.createElement(DotsOnImage, {
            block: data
          }));
        }
      default:
        {
          return /*#__PURE__*/React.createElement("div", {
            className: styles$r.object
          }, /*#__PURE__*/React.createElement("div", {
            className: makeClassName([[styles$r.wrapper, true], [styles$r.isProportional, isProportional]]),
            style: style
          }, /*#__PURE__*/React.createElement(DangerousHTML, {
            className: styles$r.objectWrap,
            html: html
          })));
        }
    }
  };
  if (isProportional) {
    style.aspectRatio = `${block.data.width} / ${block.data.height}`;
  }
  let classNames = [[styles$r.root, true], [styles$r.cc, cc], [styles$r[display], !!display && styles$r[display]], [styles$r[provider], !!provider && !!styles$r[provider]], [styles$r[onlyOn], !!onlyOn && styles$r[onlyOn]], [styles$r.mobileFullwidth, mobileFullwidth], [styles$r.proportional, isProportional]];
  // Убираем из контекста все, что не начинается с приставки isIn,
  // чтобы не применились лишние модификаторы
  // TODO: в w6 модификаторы должны передаваться явно
  if (styleContext && Array.isArray(styleContext)) {
    const filteredContext = styleContext.filter(key => key.startsWith('isIn') && styles$r[key]).reduce((acc, key) => {
      acc.push(key);
      return acc;
    }, []);
    classNames = makeStyleContext(classNames, filteredContext, styles$r);
  }
  return /*#__PURE__*/React.createElement("figure", {
    className: makeClassName(classNames)
  }, children && (/*#__PURE__*/React.createElement("div", {
    className: styles$r.object
  }, /*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$r.wrapper, true], [styles$r.isProportional, isProportional]]),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$r.objectWrap
  }, children)))), !children && renderEmbed(style), cc === 'default' && /*#__PURE__*/React.createElement("figcaption", null, renderCC()), cc === 'button' && (/*#__PURE__*/React.createElement("button", {
    className: styles$r.control,
    type: "button",
    "aria-label": "Open",
    onClick: () => {
      setIsPopoverShown(!isPopoverShown);
    }
  })), cc === 'button' && isPopoverShown && (/*#__PURE__*/React.createElement(Popover, {
    onClose: () => {
      setIsPopoverShown(false);
    }
  }, renderCC('isInPopover'))));
};
const IframeBlock = _ref29 => {
  let {
    block,
    block: {
      id
    },
    styleContext,
    lang = 'ru'
  } = _ref29;
  const element = useRef(null);
  const renderIframe = () => {
    const rootEl = document.createElement('div');
    const contentEl = document.createElement('div');
    const scriptEl = document.createElement('script');
    const style = document.createElement('style');
    const range = document.createRange();
    range.setStart(contentEl, 0);
    contentEl.setAttribute('id', 'content');
    scriptEl.textContent = `
        function getDocHeight() {
            var doc = document;
            var body = doc.body;
            var html = doc.documentElement;
            var height = Math.max( body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight );

            doc.body.style.margin="0";

            return document.getElementById('content') ? document.getElementById('content').offsetHeight : height;
        }

        function sendDocHeightMsg() {
            var height = getDocHeight();
            var message = JSON.stringify({
                action: {
                    type: "UPDATE_HEIGHT",
                    payload: {
                        id: "${block.id}",
                        height: height
                    }
                }
            });
            parent.postMessage("mdzMaterialEmbedHeight=" + message, '*');
        }

        setInterval(sendDocHeightMsg, 300);
        `;
    style.type = 'text/css';
    style.innerHTML = block.type === 'embed_code' ? '.twitter-tweet { padding-top: 15px; margin: 0 !important; }' : '.twitter-tweet { margin: 0 !important; } .fb-post { display: block; } .instagram-media { min-width: 0 !important; }';
    contentEl.appendChild(range.createContextualFragment(block.data.html));
    rootEl.appendChild(scriptEl);
    rootEl.appendChild(contentEl);
    contentEl.appendChild(style);
    const frame = element.current.querySelector('iframe').contentDocument;
    frame.open();
    frame.close();
    frame.documentElement.setAttribute('lang', lang);
    frame.body.appendChild(rootEl);
  };
  useEffect(() => {
    renderIframe();
  }, []);
  return /*#__PURE__*/React.createElement(EmbedBlock, {
    block: block,
    styleContext: styleContext
  }, /*#__PURE__*/React.createElement("div", {
    ref: element,
    dangerouslySetInnerHTML: {
      __html: `<iframe id=${id} frameBorder="0" scrolling="no"></iframe>`
    }
  }));
};
const EmbedBlockContainer = _ref30 => {
  let {
    block,
    styleContext,
    lang
  } = _ref30;
  if (block.data && block.data.wrap_with_iframe) {
    return /*#__PURE__*/React.createElement(IframeBlock, {
      block: block,
      styleContext: styleContext,
      lang: lang
    });
  }
  return /*#__PURE__*/React.createElement(EmbedBlock, {
    block: block,
    styleContext: styleContext
  });
};
var styles$q = {
  "root": "QuoteBlock-module_root__4qa1J",
  "center": "QuoteBlock-module_center__1f83y"
};
const QuoteBlock = _ref31 => {
  let {
    block: {
      data
    },
    styleContext
  } = _ref31;
  let classNames = [[styles$q.root, true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$q);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "quote-block",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: data
    }
  }));
};
var styles$p = {
  "root": "CardTitle-module_root__Pvx--",
  "index": "CardTitle-module_index__Keled",
  "title": "CardTitle-module_title__Lkflo",
  "mobile": "CardTitle-module_mobile__6N3hB",
  "desktop": "CardTitle-module_desktop__sBokS"
};
const CardTitle = _ref32 => {
  let {
    block: {
      data: {
        only_on: onlyOn,
        index,
        text
      },
      id
    },
    styleContext
  } = _ref32;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "card-title",
    id: id,
    className: makeClassName([[styles$p.root, true], [styles$p[onlyOn], !!onlyOn], [styles$p[styleContext], !!styleContext && !!styles$p[styleContext]]])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$p.index
  }, index), /*#__PURE__*/React.createElement("h3", {
    className: styles$p.title
  }, text));
};
var styles$o = {
  "root": "ChapterBlock-module_root__iw7d2",
  "subtitle": "ChapterBlock-module_subtitle__IpWgz",
  "mobile": "ChapterBlock-module_mobile__V1Eye",
  "desktop": "ChapterBlock-module_desktop__9xWf4"
};
const ChapterBlock = _ref33 => {
  let {
    block: {
      data,
      only_on: onlyOn
    },
    styleContext,
    id
  } = _ref33;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "chapter-block",
    id: id,
    className: makeClassName([[styles$o.root, true], [styles$o[onlyOn], !!onlyOn]])
  }, /*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles$o.subtitle, true], [styles$o[styleContext], !!styleContext && !!styles$o[styleContext]]]),
    dangerouslySetInnerHTML: {
      __html: data
    }
  }));
};
const generateGradient = (color, type) => {
  const steps = {
    mediaBlockBottom: [[0, 7], [0.08, 12], [0.16, 17], [0.22, 21], [0.32, 26], [0.42, 32], [0.52, 38], [0.62, 47], [0.72, 57], [0.82, 65], [1, 82]],
    mediaBlockTop: [[0.5, 0], [0, 97]]
  };
  const gradient = steps[type].map(i => `rgba(${color}, ${i[0]}) ${i[1]}%`);
  return `linear-gradient(-180deg, ${gradient})`;
};
var styles$n = {
  "root": "SimpleTitle-module_root__YOzNn",
  "mobile": "SimpleTitle-module_mobile__1QiJd",
  "desktop": "SimpleTitle-module_desktop__ZF5Af"
};
const SimpleTitle = _ref34 => {
  let {
    block: {
      data: {
        first
      },
      only_on: onlyOn
    },
    styleContext
  } = _ref34;
  let classNames = [[styles$n.root, true], [styles$n[onlyOn], true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$n);
  }
  return /*#__PURE__*/React.createElement("h1", {
    "data-testid": "simple-title",
    className: makeClassName(classNames)
  }, first);
};
var styles$m = {
  "root": "RichTitle-module_root__U5XQu",
  "slide": "RichTitle-module_slide__eU9Ob",
  "game": "RichTitle-module_game__S1csb",
  "podcastMaterial": "RichTitle-module_podcastMaterial__AulVF",
  "half": "RichTitle-module_half__yBMby",
  "featured": "RichTitle-module_featured__ULNQn",
  "isInMediaBlock": "RichTitle-module_isInMediaBlock__2h6rl",
  "isInBookRelated": "RichTitle-module_isInBookRelated__LcCPV",
  "isInDynamicBlock": "RichTitle-module_isInDynamicBlock__J-gM6",
  "isInPodcastPlayer": "RichTitle-module_isInPodcastPlayer__kvEPH",
  "large": "RichTitle-module_large__n2URP",
  "medium": "RichTitle-module_medium__KkBLJ",
  "mobile": "RichTitle-module_mobile__W5L9E",
  "desktop": "RichTitle-module_desktop__k0PkC"
};
const RichTitle = _ref35 => {
  let {
    block: {
      only_on: onlyOn,
      data: {
        featured,
        first,
        second,
        as: TagName = 'h1'
      }
    },
    styleContext,
    size = 'default'
  } = _ref35;
  let classNames = [[styles$m.root, true], [styles$m[onlyOn], true], [styles$m.featured, !!featured], [styles$m[size], !!size]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$m);
  }
  return /*#__PURE__*/React.createElement(TagName, {
    "data-testid": "rich-title",
    className: makeClassName(classNames)
  }, first, second && /*#__PURE__*/React.createElement("span", null, " ", second));
};
var styles$l = {
  "p": "SimpleBlock-module_p__7aRnT",
  "h2": "SimpleBlock-module_h2__aWlMn",
  "h3": "SimpleBlock-module_h3__uPh0-",
  "h4": "SimpleBlock-module_h4__MxGXA",
  "lead": "SimpleBlock-module_lead__NzEPT",
  "lead_hr": "SimpleBlock-module_lead_hr__XN0rm",
  "context_p": "SimpleBlock-module_context_p__Mdu1R",
  "blockquote": "SimpleBlock-module_blockquote__nX-Ab",
  "game": "SimpleBlock-module_game__uVeJJ",
  "slide": "SimpleBlock-module_slide__MaaUF",
  "dark": "SimpleBlock-module_dark__qtLhq",
  "divider": "SimpleBlock-module_divider__-VXBu",
  "isInIntro": "SimpleBlock-module_isInIntro__UOePf",
  "center": "SimpleBlock-module_center__D1CsV",
  "isInImportantLead": "SimpleBlock-module_isInImportantLead__qzKDo",
  "podcastMaterial": "SimpleBlock-module_podcastMaterial__XEMjh",
  "isInAnswer": "SimpleBlock-module_isInAnswer__Asx7d",
  "mobile": "SimpleBlock-module_mobile__EVGYJ",
  "desktop": "SimpleBlock-module_desktop__6ZH5e",
  "isDark": "SimpleBlock-module_isDark__ehYKr"
};
const SimpleBlock = _ref36 => {
  let {
    block: {
      data,
      type,
      only_on: onlyOn
    },
    styleContext,
    id = null
  } = _ref36;
  let TagName;
  let classNames = [[styles$l[type], !!type && !!styles$l[type]], [styles$l[onlyOn], true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$l);
  }
  switch (type) {
    case 'context_p':
    case 'lead':
    case 'note_caption':
    case 'note_credit':
      {
        TagName = 'p';
        break;
      }
    case 'divider':
      return /*#__PURE__*/React.createElement("hr", {
        className: makeClassName(classNames)
      });
    case 'lead_hr':
      {
        TagName = 'div';
        break;
      }
    default:
      TagName = type;
  }
  return /*#__PURE__*/React.createElement(TagName, {
    className: makeClassName(classNames),
    dangerouslySetInnerHTML: {
      __html: data
    },
    id: id
  });
};
var styles$k = {
  "root": "ListBlock-module_root__dqomP",
  "ol": "ListBlock-module_ol__1l6nP",
  "ul": "ListBlock-module_ul__bgHlv",
  "center": "ListBlock-module_center__bEBN-",
  "isInImportantLead": "ListBlock-module_isInImportantLead__ewcD1",
  "dark": "ListBlock-module_dark__NzpYz",
  "mobile": "ListBlock-module_mobile__qEBsn",
  "desktop": "ListBlock-module_desktop__HN0IU"
};
const ListBlock = _ref37 => {
  let {
    block: {
      type,
      data,
      only_on: onlyOn
    },
    styleContext
  } = _ref37;
  const TagName = type;
  let classNames = [[styles$k.root, true], [styles$k[onlyOn], true], [styles$k[type], !!type && !!styles$k[type]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$k);
  }
  return /*#__PURE__*/React.createElement(TagName, {
    className: makeClassName(classNames),
    "data-testid": "list-block"
  }, data.map((item, index) => (/*#__PURE__*/React.createElement("li", {
    key: index,
    dangerouslySetInnerHTML: {
      __html: item
    }
  }))));
};
var styles$j = {
  "root": "RelatedBlock-module_root__cr1c-",
  "header": "RelatedBlock-module_header__bfUJD",
  "items": "RelatedBlock-module_items__rzzam",
  "rich": "RelatedBlock-module_rich__1cWdn",
  "first": "RelatedBlock-module_first__ZkcP5",
  "simple": "RelatedBlock-module_simple__m22bj",
  "center": "RelatedBlock-module_center__WVpIJ",
  "isInSlideMaterial": "RelatedBlock-module_isInSlideMaterial__VumDw",
  "mobile": "RelatedBlock-module_mobile__AScBA",
  "desktop": "RelatedBlock-module_desktop__uMXUY"
};
const RelatedBlock = _ref38 => {
  let {
    block: {
      data: {
        title,
        related
      },
      only_on: onlyOn
    },
    styleContext
  } = _ref38;
  let classNames = [[styles$j.root, true], [styles$j[onlyOn], true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$j);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "related-block",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles$j.header
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: styles$j.items
  }, related.map((item, index) => (/*#__PURE__*/React.createElement("li", {
    key: item.id || index,
    className: styles$j[item.layout]
  }, /*#__PURE__*/React.createElement(Link, {
    to: item.full_url || `/${item.url}`
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$j.first
  }, item.title), item.second_title && ' ', item.second_title && /*#__PURE__*/React.createElement("span", null, item.second_title)))))));
};
var styles$i = {
  "root": "SourceBlock-module_root__9dnI4",
  "text": "SourceBlock-module_text__M5-uy",
  "origin": "SourceBlock-module_origin__fyvxH",
  "center": "SourceBlock-module_center__UOMwy",
  "mobile": "SourceBlock-module_mobile__QVEyg",
  "desktop": "SourceBlock-module_desktop__xdXWm",
  "isDark": "SourceBlock-module_isDark__etwk1"
};
const SourceBlock = _ref39 => {
  let {
    block: {
      only_on: onlyOn,
      data: {
        quote,
        origin,
        url
      }
    },
    styleContext
  } = _ref39;
  let classNames = [[styles$i.root, true], [styles$i[onlyOn], true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$i);
  }
  return /*#__PURE__*/React.createElement("blockquote", {
    "data-testid": "source-block",
    cite: url,
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("a", {
    className: styles$i.text,
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, quote.map((item, index) => (/*#__PURE__*/React.createElement("p", {
    key: index,
    dangerouslySetInnerHTML: {
      __html: item.data
    }
  }))), /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("cite", {
    className: styles$i.origin
  }, origin))));
};
var styles$h = {
  "root": "SensitiveBlock-module_root__1Nl9-",
  "container": "SensitiveBlock-module_container__GE2tW",
  "overlay": "SensitiveBlock-module_overlay__tEsK8",
  "content": "SensitiveBlock-module_content__RYbdd",
  "button": "SensitiveBlock-module_button__LGEEM",
  "default": "SensitiveBlock-module_default__pkWhC",
  "full": "SensitiveBlock-module_full__hlH41",
  "media": "SensitiveBlock-module_media__nuL1S",
  "super_full": "SensitiveBlock-module_super_full__C7UyP",
  "visible": "SensitiveBlock-module_visible__bXhYO",
  "isInCard": "SensitiveBlock-module_isInCard__uANYL",
  "isInSlide": "SensitiveBlock-module_isInSlide__ZAVUU"
};
const SensitiveBlock = _ref40 => {
  let {
    block,
    block: {
      cc,
      caption,
      credit,
      blurred_image: blurredImage
    },
    block: {
      item: {
        data: {
          display
        }
      }
    },
    styleContext
  } = _ref40;
  const [visible, isVisible] = useState(false);
  const handleClick = () => {
    isVisible(true);
  };
  let classNames = [[styles$h.root, true], [styles$h.visible, visible], [styles$h[display], display && styles$h[display]]];
  let context = ['isInSensitiveBlock'];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$h);
    context = [...styleContext, 'isInSensitiveBlock'];
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "sensitive-block",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$h.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$h.overlay,
    style: {
      backgroundImage: `url(${blurredImage})`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$h.content
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: block.title
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$h.button
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleClick(),
    theme: "light"
  }, block.button.text)))), /*#__PURE__*/React.createElement("div", {
    className: styles$h.media
  }, /*#__PURE__*/React.createElement(EmbedBlockContainer, {
    block: block.item,
    styleContext: context
  }))), cc && (/*#__PURE__*/React.createElement("figcaption", {
    className: styles$h.figcaption
  }, /*#__PURE__*/React.createElement(MediaCaption, {
    credit: credit,
    caption: caption,
    styleContext: styleContext
  }))));
};
var styles$g = {
  "root": "GroupedBlock-module_root__MQQin",
  "hasFigcaption": "GroupedBlock-module_hasFigcaption__Y05ed",
  "item": "GroupedBlock-module_item__-InqF",
  "items": "GroupedBlock-module_items__8X4js",
  "figcaption": "GroupedBlock-module_figcaption__OE5-u",
  "default": "GroupedBlock-module_default__Tha8f",
  "full": "GroupedBlock-module_full__SNwyE",
  "super_full": "GroupedBlock-module_super_full__HTA9D",
  "mobile": "GroupedBlock-module_mobile__xqMw5",
  "desktop": "GroupedBlock-module_desktop__Oobdp"
};
const GroupedBlock = _ref41 => {
  let {
    block,
    block: {
      only_on: onlyOn
    },
    styleContext
  } = _ref41;
  const maxHeight = Math.min(...block.data.map(item => item.data && item.data.height || item.item && item.item.data.height));
  const normalizedBoxesWidth = block.data.map(item => {
    const width = item.data && item.data.width || item.item && item.item.data.heigh;
    const height = item.data && item.data.height || item.item && item.item.data.heigh;
    return width / (height / maxHeight);
  });
  const sumWidth = normalizedBoxesWidth.reduce((sum, x) => sum + x);
  let classNames = [[styles$g.root, true], [styles$g[onlyOn], true], [styles$g.hasFigcaption, block.cc === 'default'], [styles$g[block.display], !!block.display && styles$g[block.display]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$g);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "grouped-block",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$g.items
  }, block.data.map((item, index) => {
    const percentWidth = normalizedBoxesWidth[index] / sumWidth * 100;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$g.item,
      key: item.id,
      style: {
        width: `${percentWidth}%`
      }
    }, item.type === 'sensitive' ? (/*#__PURE__*/React.createElement(SensitiveBlock, {
      block: item,
      styleContext: ['isInGroupedBlock']
    })) : (/*#__PURE__*/React.createElement(EmbedBlockContainer, {
      block: item,
      styleContext: ['isInGroupedBlock']
    })));
  })), block.cc && (/*#__PURE__*/React.createElement("figcaption", {
    className: styles$g.figcaption
  }, /*#__PURE__*/React.createElement(MediaCaption, {
    credit: block.credit,
    caption: block.caption,
    styleContext: styleContext
  }))));
};
var styles$f = {
  "root": "MetaItem-module_root__sRbrZ",
  "hasBullets": "MetaItem-module_hasBullets__b1eW9",
  "hasSource": "MetaItem-module_hasSource__35olm",
  "listened": "MetaItem-module_listened__XZWFQ",
  "read": "MetaItem-module_read__O3cUz",
  "datetime": "MetaItem-module_datetime__--O8c"
};
const MetaItem = _ref42 => {
  let {
    hasSource,
    type,
    children,
    bullets
  } = _ref42;
  const classNames = [[styles$f.root, true], [styles$f[type], !!type && !!styles$f[type]], [styles$f.hasSource, !!hasSource], [styles$f.hasBullets, !!bullets]];
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "meta-item",
    className: makeClassName(classNames)
  }, children);
};
var styles$e = {
  "root": "MetaItemLive-module_root__XfQiW",
  "gold": "MetaItemLive-module_gold__f1UOy",
  "frame": "MetaItemLive-module_frame__FHByQ",
  "liveMiddle": "MetaItemLive-module_liveMiddle__SX4Gs",
  "liveFirstWave": "MetaItemLive-module_liveFirstWave__QqstP",
  "liveSecondWave": "MetaItemLive-module_liveSecondWave__hlbpt"
};
const MetaItemLive = _ref43 => {
  let {
    theme = 'gold'
  } = _ref43;
  const classNames = [[styles$e.root, true], [styles$e[theme], !!theme && styles$e[theme]]];
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "meta-item-live",
    "data-meta": "live",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$e.frame
  }));
};
const pluralize = (number, one, two, five) => {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return five;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return two;
  }
  return five;
};
var styles$d = {
  "root": "DocumentItemsCount-module_root__u4M3y",
  "items": "DocumentItemsCount-module_items__OE-hf"
};
const DocumentItemsCount = _ref44 => {
  let {
    type,
    lang = 'ru',
    items,
    children
  } = _ref44;
  const i18n = {
    ru: {
      card: {
        one: 'карточка',
        two: 'карточки',
        five: 'карточек'
      },
      podcast: {
        one: 'эпизод',
        two: 'эпизода',
        five: 'эпизодов'
      }
    },
    en: {
      card: {
        one: 'card',
        two: 'cards',
        five: 'cards'
      },
      podcast: {
        one: 'episode',
        two: 'episodes',
        five: 'episodes'
      }
    }
  };
  const itemsCount = `${items} ${pluralize(items, i18n[lang][type].one, i18n[lang][type].two, i18n[lang][type].five)}`;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "document-items-count",
    className: styles$d.root
  }, children, /*#__PURE__*/React.createElement("span", {
    className: styles$d.items
  }, itemsCount));
};
const MetaContainer = _ref45 => {
  let {
    lang,
    block,
    isRead,
    isListened,
    bookmarkAction,
    isInBookmarks,
    block: {
      data: {
        components,
        theme
      }
    },
    styleContext
  } = _ref45;
  const themeColor = styleContext && styleContext.indexOf('dark') !== -1 ? 'light' : 'unset';
  const isPodcast = styleContext && styleContext.indexOf('podcast') !== -1;
  const isSlides = styleContext && styleContext.indexOf('slide') !== -1;
  let context = [];
  if (styleContext && Array.isArray(styleContext)) {
    context = styleContext.filter(item => {
      return item !== 'dark';
    });
  }
  const hasSource = !!components.find(item => item.type === 'source_name');
  return /*#__PURE__*/React.createElement(Meta, {
    styleContext: context,
    theme: theme || themeColor,
    onlyOn: block.only_on,
    hasSource: hasSource
  }, components.map(component => {
    switch (component.type) {
      case 'source_name':
        {
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id
          }, /*#__PURE__*/React.createElement(React.Fragment, null, lang === 'ru' ? 'Источник: ' : 'Source: ', component.url && (/*#__PURE__*/React.createElement("a", {
            href: component.url,
            rel: "noopener noreferrer",
            target: "_blank"
          }, component.text)), !component.url && component.text));
        }
      case 'duration':
        {
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id
          }, /*#__PURE__*/React.createElement(React.Fragment, null, styleContext !== 'isInDynamicBlock' && (/*#__PURE__*/React.createElement(SvgSymbol, {
            icon: "podcast",
            size: "small"
          })), component.text));
        }
      case 'datetime':
        {
          const format = component.format && toCamel(component.format) || 'date';
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id,
            type: "datetime"
          }, /*#__PURE__*/React.createElement(Timestamp, {
            publishedAt: component.datetime,
            type: format || 'date',
            locale: lang
          }));
        }
      case 'items_count':
        {
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id
          }, /*#__PURE__*/React.createElement(DocumentItemsCount, {
            items: component.count,
            type: isPodcast ? 'podcast' : 'card',
            lang: lang
          }, /*#__PURE__*/React.createElement(SvgSymbol, {
            icon: "card",
            size: "unset"
          })));
        }
      case 'broadcast_active':
        {
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id
          }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MetaItemLive, null), " \u041F\u0440\u044F\u043C\u043E\u0439 \u044D\u0444\u0438\u0440"));
        }
      case 'broadcast':
        {
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id
          }, /*#__PURE__*/React.createElement(React.Fragment, null, component.with_icon && /*#__PURE__*/React.createElement(MetaItemLive, null), component.label));
        }
      case 'string':
        {
          return /*#__PURE__*/React.createElement(MetaItem, {
            hasSource: hasSource,
            bullets: true,
            key: component.id
          }, component.text);
        }
      default:
        {
          return null;
        }
    }
  }), (isRead || isListened) && (/*#__PURE__*/React.createElement(MetaItem, {
    hasSource: hasSource,
    bullets: true,
    type: isListened ? 'listened' : 'read'
  }, /*#__PURE__*/React.createElement(SvgSymbol, {
    icon: isListened ? 'listened' : 'read',
    size: "unset"
  }))), isSlides && lang === 'ru' && (/*#__PURE__*/React.createElement("div", {
    className: styles$t.bookmark
  }, /*#__PURE__*/React.createElement(BookmarkButton, {
    isInBookmarks: isInBookmarks,
    onClick: () => bookmarkAction('bookmark', 'top')
  }))));
};
var styles$c = {
  "root": "DonatesTeaser-module_root__XQCVy",
  "main": "DonatesTeaser-module_main__eN9kd",
  "title": "DonatesTeaser-module_title__9umo1",
  "text": "DonatesTeaser-module_text__s6tyf",
  "cta": "DonatesTeaser-module_cta__-50aB",
  "center": "DonatesTeaser-module_center__gxLvW",
  "isInCard": "DonatesTeaser-module_isInCard__vaUhd",
  "isInSlide": "DonatesTeaser-module_isInSlide__Dh4NH",
  "ru": "DonatesTeaser-module_ru__y-PlJ",
  "en": "DonatesTeaser-module_en__0Iisr"
};
const DonatesTeaser = _ref46 => {
  let {
    styleContext,
    lang = 'ru'
  } = _ref46;
  let classNames = [[styles$c.root, true], [styles$c[lang], styles$c[lang]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$c);
  }
  const data = {
    ru: {
      title: '«Медуза». Работаем 24/7. И&nbsp;только&nbsp;в&nbsp;интересах читателей',
      subtitle: 'Нам срочно нужна ваша поддержка',
      button: 'Хочу помочь',
      href: 'https://support.meduza.io/'
    },
    en: {
      title: 'Meduza, working 24/7, always&nbsp;for our readers',
      subtitle: 'We&nbsp;need&nbsp;your&nbsp;help like never&nbsp;before',
      button: 'Okay!',
      href: 'https://support.meduza.io/en'
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "donates-teaser",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$c.main
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles$c.title
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: data[lang].title
    }
  }), ` `, /*#__PURE__*/React.createElement("span", {
    className: styles$c.text,
    dangerouslySetInnerHTML: {
      __html: data[lang].subtitle
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$c.cta
  }, /*#__PURE__*/React.createElement("a", {
    href: data[lang].href,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("span", null, data[lang].button))));
};
var styles$b = {
  "root": "AnnouncementInText-module_root__C4-Oo",
  "body": "AnnouncementInText-module_body__lZy-L",
  "title": "AnnouncementInText-module_title__cb6i1",
  "footer": "AnnouncementInText-module_footer__jRk9p",
  "button": "AnnouncementInText-module_button__JuT-E",
  "link": "AnnouncementInText-module_link__C0YxL",
  "center": "AnnouncementInText-module_center__1DJjd",
  "isInCard": "AnnouncementInText-module_isInCard__jIqpa",
  "isInSlide": "AnnouncementInText-module_isInSlide__BWO-A",
  "ru": "AnnouncementInText-module_ru__QHQad",
  "en": "AnnouncementInText-module_en__r0PvM"
};
const AnnouncementInText = _ref47 => {
  let {
    styleContext,
    lang = 'ru'
  } = _ref47;
  let classNames = [[styles$b.root, true], [styles$b[lang], styles$b[lang]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$b);
  }
  const data = {
    ru: {
      title: '&laquo;Медуза&raquo; заблокирована в&nbsp;России. Мы&nbsp;были к&nbsp;этому готовы&nbsp;&mdash; и&nbsp;продолжаем работать. Несмотря&nbsp;ни&nbsp;на&nbsp;что',
      text: '<p>Нам нужна ваша помощь как никогда. Прямо сейчас. Дальше всем нам будет еще труднее. Мы&nbsp;независимое издание и&nbsp;работаем только в&nbsp;интересах читателей.</p>',
      button: 'Хочу помочь',
      href: 'https://mdza.io/yiNxPZ7Bs-k'
    },
    en: {
      title: 'Meduza has been blocked in Russia. We&nbsp;were ready for this and our work continues, no matter what, but we need your support like never before. ',
      text: '<p>We need it now. Tomorrow could be too late. We are an independent publication, and we work only in the interests of our readers. Many&nbsp;of&nbsp;our&nbsp;readers in Russia can no longer contribute, so we turn to you, our audience around the world.</p>',
      button: 'I want to help',
      href: 'https://support.meduza.io/en'
    }
  };
  const localeData = data[lang];
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "announcement-in-text",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$b.body
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles$b.title,
    dangerouslySetInnerHTML: {
      __html: localeData.title
    }
  }), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: localeData.text
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$b.footer
  }, /*#__PURE__*/React.createElement("a", {
    className: styles$b.link,
    href: localeData.href,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("span", null, localeData.button)), /*#__PURE__*/React.createElement("span", {
    className: styles$b.button
  }, /*#__PURE__*/React.createElement("span", null, localeData.button))));
};
var styles$a = {
  "root": "VersesBlock-module_root__CrgSZ",
  "ol": "VersesBlock-module_ol__ToXjg",
  "ul": "VersesBlock-module_ul__wfaQD",
  "center": "VersesBlock-module_center__E1IS-",
  "isInImportantLead": "VersesBlock-module_isInImportantLead__pdugk",
  "dark": "VersesBlock-module_dark__FwaPS",
  "mobile": "VersesBlock-module_mobile__EcHvz",
  "desktop": "VersesBlock-module_desktop__quKfJ"
};
const VersesBlock = _ref48 => {
  let {
    block: {
      type,
      data,
      only_on: onlyOn
    },
    styleContext
  } = _ref48;
  let classNames = [[styles$a.root, true], [styles$a[onlyOn], true], [styles$a[type], !!type && !!styles$a[type]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$a);
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: makeClassName(classNames),
    "data-testid": "verses-block"
  }, data.map((item, index) => (/*#__PURE__*/React.createElement("li", {
    key: index,
    dangerouslySetInnerHTML: {
      __html: item
    }
  }))));
};
const RenderBlocks = _ref49 => {
  let {
    block,
    styleContext,
    lang,
    isRead,
    isListened,
    bookmarkAction,
    isInBookmarks
  } = _ref49;
  switch (block.type) {
    case 'tag':
      {
        return /*#__PURE__*/React.createElement(Tag, {
          size: "large",
          onlyOn: block.only_on,
          theme: block.data.theme,
          styleContext: styleContext
        }, block.data.text);
      }
    case 'simple_title':
      {
        return /*#__PURE__*/React.createElement(SimpleTitle, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'rich_title':
      {
        return /*#__PURE__*/React.createElement(RichTitle, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'meta':
      {
        return /*#__PURE__*/React.createElement(MetaContainer, {
          block: block,
          lang: block.data.lang,
          styleContext: styleContext,
          isRead: isRead,
          isListened: isListened,
          isInBookmarks: isInBookmarks,
          bookmarkAction: bookmarkAction
        });
      }
    case 'blockquote':
    case 'p':
    case 'context_p':
    case 'divider':
    case 'lead':
    case 'lead_hr':
      {
        return /*#__PURE__*/React.createElement(SimpleBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
      {
        return /*#__PURE__*/React.createElement(SimpleBlock, {
          block: block,
          styleContext: styleContext,
          id: block.id
        });
      }
    case 'quote':
      return /*#__PURE__*/React.createElement(QuoteBlock, {
        block: block,
        styleContext: styleContext
      });
    case 'ol':
    case 'ul':
      {
        return /*#__PURE__*/React.createElement(ListBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'verses':
      {
        return /*#__PURE__*/React.createElement(VersesBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'chapter-subtitle':
      {
        return /*#__PURE__*/React.createElement(ChapterBlock, {
          block: block,
          styleContext: styleContext,
          id: block.id
        });
      }
    case 'card_title':
      {
        return /*#__PURE__*/React.createElement(CardTitle, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'related':
      {
        return /*#__PURE__*/React.createElement(RelatedBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'source':
      return /*#__PURE__*/React.createElement(SourceBlock, {
        block: block,
        styleContext: styleContext
      });
    case 'table':
      return /*#__PURE__*/React.createElement(Table, {
        block: block,
        styleContext: styleContext
      });
    case 'sensitive':
      return /*#__PURE__*/React.createElement(SensitiveBlock, {
        block: block,
        styleContext: styleContext
      });
    case 'embed':
    case 'embed_code':
    case 'game_embed':
    case 'image':
    case 'dots_on_image':
    case 'gif':
      return /*#__PURE__*/React.createElement(EmbedBlockContainer, {
        block: block,
        styleContext: styleContext,
        lang: lang
      });
    case 'grouped':
      return /*#__PURE__*/React.createElement(GroupedBlock, {
        block: block,
        styleContext: styleContext
      });
    case 'donation':
      return /*#__PURE__*/React.createElement(DonatesTeaser, {
        styleContext: styleContext,
        lang: lang
      });
    case 'material_note':
      return /*#__PURE__*/React.createElement(MaterialNote, {
        block: block,
        styleContext: styleContext
      });
    case 'announcement_in_text':
      return /*#__PURE__*/React.createElement(AnnouncementInText, {
        styleContext: styleContext,
        lang: lang
      });
    default:
      {
        return null;
      }
  }
};
var styles$9 = {
  "root": "Cover-module_root__3pscq",
  "body": "Cover-module_body__eJpUI",
  "image": "Cover-module_image__frrrH",
  "rich": "Cover-module_rich__YcxWa",
  "dark": "Cover-module_dark__cRucL",
  "light": "Cover-module_light__la-sk",
  "control": "Cover-module_control__WP0G3",
  "isInDynamicBlock": "Cover-module_isInDynamicBlock__qO-yt",
  "mobile": "Cover-module_mobile__aotep",
  "desktop": "Cover-module_desktop__dfbC-"
};
const Cover = _ref50 => {
  let {
    block: {
      only_on: onlyOn,
      data: {
        blocks,
        cover: {
          credit,
          caption,
          urls,
          mobile_ratio: mobileRatio,
          gradients,
          cc
        }
      }
    },
    styleContext
  } = _ref50;
  const [isPopoverShown, setIsPopoverShown] = useState(false);
  const style = {};
  let classNames = [[styles$9.root, true], [styles$9[onlyOn], !!onlyOn && !!styles$9[onlyOn]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$9);
  }
  if (gradients) {
    const theme = [gradients.text_rgb === '0,0,0' ? 'dark' : 'light'];
    classNames = makeStyleContext(classNames, theme, styles$9);
    style.backgroundImage = generateGradient(gradients.bg_rgb, 'mediaBlockBottom');
  }
  const renderCC = context => (/*#__PURE__*/React.createElement(MediaCaption, {
    credit: credit,
    caption: caption,
    styleContext: context || styleContext
  }));
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "cover",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.image
  }, /*#__PURE__*/React.createElement(Image, {
    optimized: urls,
    ratio: mobileRatio,
    display: "narrow"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$9.body,
    style: style
  }, blocks.map(item => (/*#__PURE__*/React.createElement(RenderBlocks, {
    key: item.id,
    block: item,
    styleContext: styleContext
  })))), cc === 'button' && (/*#__PURE__*/React.createElement("button", {
    className: styles$9.control,
    type: "button",
    "aria-label": "Open",
    onClick: () => {
      setIsPopoverShown(!isPopoverShown);
    }
  })), cc === 'button' && isPopoverShown && (/*#__PURE__*/React.createElement(Popover, {
    onClose: () => {
      setIsPopoverShown(false);
    }
  }, renderCC('isInPopover'))));
};
var styles$8 = {
  "root": "HalfBlock-module_root__EXQbz",
  "main": "HalfBlock-module_main__eIcRo",
  "body": "HalfBlock-module_body__HPhGj",
  "footer": "HalfBlock-module_footer__TFfCQ",
  "image": "HalfBlock-module_image__XWLbK",
  "mobile": "HalfBlock-module_mobile__uGGpm",
  "desktop": "HalfBlock-module_desktop__p-hAq"
};
const HalfBlock = _ref51 => {
  let {
    block: {
      only_on: onlyOn,
      data,
      data: {
        cover: {
          optimized,
          ratio,
          credit,
          caption
        }
      }
    },
    styleContext
  } = _ref51;
  let classNames = [[styles$8.root, true], [styles$8[onlyOn], true]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$8);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "half-block",
    className: makeClassName(classNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$8.main
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$8.image
  }, /*#__PURE__*/React.createElement(Image, {
    optimized: optimized,
    ratio: ratio,
    display: "super_full"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$8.body
  }, data.blocks.map(item => (/*#__PURE__*/React.createElement(RenderBlocks, {
    key: item.id,
    block: item,
    styleContext: ['rich']
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles$8.footer
  }, /*#__PURE__*/React.createElement(MediaCaption, {
    credit: credit,
    caption: caption,
    styleContext: styleContext
  })));
};
var styles$7 = {
  "root": "ImportantLead-module_root__-rnt6",
  "slide": "ImportantLead-module_slide__zcovu",
  "mobile": "ImportantLead-module_mobile__msInp",
  "desktop": "ImportantLead-module_desktop__ELC2-"
};
const ImportantLead = _ref52 => {
  let {
    block: {
      only_on: onlyOn,
      data
    },
    styleContext
  } = _ref52;
  let classNames = [[styles$7.root, true], [styles$7[onlyOn], !!onlyOn]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$7);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "important-lead",
    className: makeClassName(classNames)
  }, data.map(item => (/*#__PURE__*/React.createElement(RenderBlocks, {
    key: item.id,
    block: item,
    styleContext: "isInImportantLead"
  }))));
};
var styles$6 = {
  "root": "Spoiler-module_root__fAbb9",
  "header": "Spoiler-module_header__iEKsQ",
  "body": "Spoiler-module_body__jjqIn",
  "spoiled": "Spoiler-module_spoiled__ENI93",
  "footer": "Spoiler-module_footer__g21Zn",
  "spoilerSticky": "Spoiler-module_spoilerSticky__YTiyF",
  "spoilerStickyBg": "Spoiler-module_spoilerStickyBg__tmDnG",
  "center": "Spoiler-module_center__0XCWo",
  "full": "Spoiler-module_full__FtKDT",
  "default": "Spoiler-module_default__wvlKw",
  "mobile": "Spoiler-module_mobile__PWCMW",
  "desktop": "Spoiler-module_desktop__qTakd"
};
const Spoiler = _ref53 => {
  let {
    block: {
      display,
      button,
      only_on: onlyOn,
      btn_title: buttonTitle,
      title,
      blocks
    },
    styleContext
  } = _ref53;
  const [spoiled, setSpoiled] = useState(false);
  const ref = useRef(null);
  const handleButtonClick = () => {
    setSpoiled(!spoiled);
    if (spoiled) {
      postMessage('', 'closeSpoiler', 'click');
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < 0) {
        ref.current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      postMessage('', 'openSpoiler', 'click');
    }
  };
  let classNames = [[styles$6.root, true], [styles$6[onlyOn], !!onlyOn], [styles$6[display], !!display && styles$6[display]], [[styles$6.spoiled], !!spoiled]];
  const context = ['center'];
  if (styleContext) {
    context.concat(styleContext);
    classNames = makeStyleContext(classNames, styleContext, styles$6);
  }
  const buttonCollapse = button ? button.collapse : 'Свернуть';
  const buttonExpande = button ? button.expand : buttonTitle;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: makeClassName(classNames),
    "data-testid": "spoiler"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$6.header
  }, title && /*#__PURE__*/React.createElement("h3", null, title)), /*#__PURE__*/React.createElement("div", {
    className: styles$6.body
  }, blocks.map(item => (/*#__PURE__*/React.createElement(RenderBlocks, {
    key: item.id,
    block: item,
    styleContext: context
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$6.footer
  }, /*#__PURE__*/React.createElement(Button, {
    size: "default",
    theme: "gray",
    onClick: () => handleButtonClick(),
    styleContext: "isInSpoiler"
  }, spoiled ? buttonCollapse : buttonExpande, /*#__PURE__*/React.createElement(SvgSymbol, {
    icon: "arrow"
  }))));
};
var styles$5 = {
  "root": "RelatedRichBlock-module_root__-SEe7",
  "wrapper": "RelatedRichBlock-module_wrapper__YkEpr",
  "overlay": "RelatedRichBlock-module_overlay__tWuyR",
  "overlayHeader": "RelatedRichBlock-module_overlayHeader__V3ynX",
  "body": "RelatedRichBlock-module_body__XhS0U",
  "isRich": "RelatedRichBlock-module_isRich__Z2kQ8",
  "hasGradient": "RelatedRichBlock-module_hasGradient__s5Krh",
  "picture": "RelatedRichBlock-module_picture__OmRKx",
  "isCard": "RelatedRichBlock-module_isCard__wkMw-",
  "cover": "RelatedRichBlock-module_cover__3gnIx",
  "tag": "RelatedRichBlock-module_tag__c18sv",
  "center": "RelatedRichBlock-module_center__KANd-",
  "dark": "RelatedRichBlock-module_dark__cnk4R",
  "light": "RelatedRichBlock-module_light__aJLn7",
  "mobile": "RelatedRichBlock-module_mobile__N-G4U",
  "desktop": "RelatedRichBlock-module_desktop__EaPOr"
};

/* eslint-disable react/jsx-no-target-blank */
const RelatedRichBlock = _ref54 => {
  let {
    block: {
      only_on: onlyOn,
      data: {
        blocks,
        url,
        cover: {
          urls,
          gradients,
          tag,
          layout,
          ratio
        }
      }
    },
    styleContext
  } = _ref54;
  const style = {};
  const styleHeader = {};
  const cardType = `is${toCapitalize(layout)}`;
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView) {
      if (onlyOn === 'mobile' && window.innerWidth <= 511 || onlyOn === 'desktop' && window.innerWidth >= 512 || !onlyOn) {
        postMessage('richRelated', url, 'view');
      }
    }
  }, [inView]);
  const handleClick = () => {
    postMessage('richRelated', url, 'click');
  };
  let classNames = [[styles$5.root, true], [styles$5[cardType], !!layout && !!styles$5[cardType]], [styles$5.hasGradient, !!gradients], [styles$5[onlyOn], !!onlyOn && !!styles$5[onlyOn]]];
  let context = ['isInMediaBlock'];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$5);
    context = [...styleContext, 'isInMediaBlock'];
  }
  if (gradients) {
    styleHeader.backgroundImage = generateGradient(gradients.bg_rgb, 'mediaBlockTop');
    const theme = [gradients.text_rgb === '0,0,0' ? 'dark' : 'light'];
    classNames = makeStyleContext(classNames, theme, styles$5);
    if (onlyOn === 'desktop') {
      style.backgroundImage = generateGradient(gradients.bg_rgb, 'mediaBlockBottom');
    }
  }
  return /*#__PURE__*/React.createElement(Link, {
    "data-testid": "related-rich-block",
    className: makeClassName(classNames),
    to: `/${url}`,
    onClick: () => handleClick(),
    ref: ref
  }, layout === 'rich' && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$5.overlay,
    style: style
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$5.overlayHeader,
    style: styleHeader
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$5.tag
  }, /*#__PURE__*/React.createElement(Tag, {
    size: "small",
    theme: "inherit",
    styleContext: "richRelated"
  }, tag)), /*#__PURE__*/React.createElement("div", {
    className: styles$5.cover
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.picture
  }, /*#__PURE__*/React.createElement(Image, {
    optimized: urls,
    ratio: ratio,
    display: "narrow"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$5.body
  }, blocks.map(item => (/*#__PURE__*/React.createElement(RenderBlocks, {
    key: item.id,
    block: item,
    styleContext: context
  })))));
};
var styles$4 = {
  "root": "ShopRelatedBlock-module_root__eTGjC",
  "wrapper": "ShopRelatedBlock-module_wrapper__v6yE3",
  "overlay": "ShopRelatedBlock-module_overlay__oR67Y",
  "overlayHeader": "ShopRelatedBlock-module_overlayHeader__YMcNw",
  "body": "ShopRelatedBlock-module_body__W4pBN",
  "hasGradient": "ShopRelatedBlock-module_hasGradient__50JTl",
  "picture": "ShopRelatedBlock-module_picture__zjFL4",
  "tag": "ShopRelatedBlock-module_tag__ixkda",
  "center": "ShopRelatedBlock-module_center__IpBP4",
  "title": "ShopRelatedBlock-module_title__COl93",
  "price": "ShopRelatedBlock-module_price__5Qitu",
  "dark": "ShopRelatedBlock-module_dark__d0QiW",
  "light": "ShopRelatedBlock-module_light__lUDWA",
  "mobile": "ShopRelatedBlock-module_mobile__I6Hih",
  "desktop": "ShopRelatedBlock-module_desktop__ywKrb"
};

/* eslint-disable react/jsx-no-target-blank */
const ShopRelatedBlock = _ref55 => {
  let {
    block: {
      only_on: onlyOn,
      data: {
        url,
        cover: {
          urls,
          gradients,
          tag,
          layout,
          ratio,
          first_title: firstTitle,
          second_title: secondTitle
        }
      }
    },
    styleContext
  } = _ref55;
  const style = {};
  const styleHeader = {};
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView) {
      if (onlyOn === 'mobile' && window.innerWidth <= 511 || onlyOn === 'desktop' && window.innerWidth >= 512 || !onlyOn) {
        postMessage('productRelated', url, 'view');
      }
    }
  }, [inView]);
  const handleClick = () => {
    postMessage('productRelated', url, 'click');
  };
  let classNames = [[styles$4.root, true], [styles$4.hasGradient, !!gradients], [styles$4[onlyOn], !!onlyOn && !!styles$4[onlyOn]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$4);
  }
  if (gradients) {
    styleHeader.backgroundImage = generateGradient(gradients.bg_rgb, 'mediaBlockTop');
    const theme = [gradients.text_rgb === '0,0,0' ? 'dark' : 'light'];
    classNames = makeStyleContext(classNames, theme, styles$4);
    if (onlyOn === 'desktop') {
      style.backgroundImage = generateGradient(gradients.bg_rgb, 'mediaBlockBottom');
    }
  }
  return /*#__PURE__*/React.createElement("a", {
    "data-testid": "related-rich-block",
    className: makeClassName(classNames),
    href: url,
    target: "_blank",
    onClick: () => handleClick(),
    ref: ref
  }, layout === 'rich' && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$4.overlay,
    style: style
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.overlayHeader,
    style: styleHeader
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$4.tag
  }, /*#__PURE__*/React.createElement(Tag, {
    size: "small",
    theme: "inherit",
    styleContext: "richRelated"
  }, tag)), /*#__PURE__*/React.createElement("div", {
    className: styles$4.cover
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.picture
  }, /*#__PURE__*/React.createElement(Image, {
    optimized: urls,
    ratio: ratio,
    display: "narrow"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$4.body
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles$4.title
  }, firstTitle, /*#__PURE__*/React.createElement("span", {
    className: styles$4.price
  }, secondTitle))));
};
var styles$3 = {
  "root": "RelatedBook-module_root__QsOmA",
  "container": "RelatedBook-module_container__vdDiZ",
  "imageWrap": "RelatedBook-module_imageWrap__WmwnE",
  "image": "RelatedBook-module_image__U1e5t",
  "picture": "RelatedBook-module_picture__NXg-K",
  "tag": "RelatedBook-module_tag__mSbbz",
  "contentWrap": "RelatedBook-module_contentWrap__HIGRi",
  "content": "RelatedBook-module_content__23Pfr",
  "title": "RelatedBook-module_title__VRbr-",
  "footer": "RelatedBook-module_footer__Z05t-",
  "center": "RelatedBook-module_center__Fa6cj",
  "isLight": "RelatedBook-module_isLight__W-0TO",
  "isDark": "RelatedBook-module_isDark__0mrtK"
};
const RelatedBook = _ref56 => {
  let {
    block,
    styleContext
  } = _ref56;
  const theme = block.data.theme.text_color === '0,0,0' ? 'isDark' : 'isLight';
  let classNames = [[styles$3.root, true], [styles$3[theme], theme], [styles$3[block.data.onlyOn], !!block.data.onlyOn && !!styles$3[block.data.onlyOn]]];
  if (styleContext) {
    classNames = makeStyleContext(classNames, styleContext, styles$3);
  }
  const cssProps = {
    '--bgColor': `rgb(${block.data.theme.background_color || '0, 0, 0'})`
  };
  return /*#__PURE__*/React.createElement(Link, {
    to: `/${block.data.url}`,
    className: makeClassName(classNames),
    style: cssProps
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.imageWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.image
  }, /*#__PURE__*/React.createElement("picture", {
    className: styles$3.picture
  }, /*#__PURE__*/React.createElement(Image, {
    optimized: block.data.cover.urls,
    ratio: 0,
    display: "narrow",
    styleContext: ['isStatic'],
    lazy: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$3.contentWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.content
  }, block.data.blocks.map(item => (/*#__PURE__*/React.createElement(RenderBlocks, {
    key: item.id,
    block: item,
    styleContext: ['isInMediaBlock', 'isInBookRelated', 'isCustom']
  })))))));
};
const RawHtmlBlock = _ref57 => {
  let {
    block,
    styleContext,
    isRead,
    isListened,
    isInBookmarks,
    bookmarkAction,
    lightBox,
    lang
  } = _ref57;
  const context = {
    lightBox: lightBox || null
  };
  switch (block.type) {
    case 'important_lead':
      {
        return /*#__PURE__*/React.createElement(ImportantLead, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'spoiler':
      {
        return /*#__PURE__*/React.createElement(BlockProvider, {
          value: context
        }, /*#__PURE__*/React.createElement(Spoiler, {
          block: block,
          styleContext: styleContext
        }));
      }
    case 'cover':
      {
        return /*#__PURE__*/React.createElement(Cover, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'half':
      {
        return /*#__PURE__*/React.createElement(HalfBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'related_rich':
      {
        return /*#__PURE__*/React.createElement(RelatedRichBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'related_book':
      {
        return /*#__PURE__*/React.createElement(RelatedBook, {
          block: block,
          styleContext: styleContext
        });
      }
    case 'related_shop':
      {
        return /*#__PURE__*/React.createElement(ShopRelatedBlock, {
          block: block,
          styleContext: styleContext
        });
      }
    default:
      {
        return /*#__PURE__*/React.createElement(BlockProvider, {
          value: context
        }, /*#__PURE__*/React.createElement(RenderBlocks, {
          block: block,
          styleContext: styleContext,
          isRead: isRead,
          isListened: isListened,
          isInBookmarks: isInBookmarks,
          bookmarkAction: bookmarkAction,
          lang: lang
        }));
      }
  }
};
var styles$2 = {
  "root": "ListViewSwitcher-module_root__pBsR5",
  "input": "ListViewSwitcher-module_input__vtDVD",
  "knob": "ListViewSwitcher-module_knob__g-OZ2",
  "sm": "ListViewSwitcher-module_sm__y1teD",
  "md": "ListViewSwitcher-module_md__0M8KR",
  "grid": "ListViewSwitcher-module_grid__qBmnM",
  "list": "ListViewSwitcher-module_list__NORMp"
};
const ListViewSwitcher = _ref58 => {
  let {
    enabled,
    onChange,
    size = 'md'
  } = _ref58;
  return /*#__PURE__*/React.createElement("label", {
    "data-testid": "listViewSwitcher",
    className: makeClassName([[styles$2.root, true], [styles$2[size], true]])
  }, /*#__PURE__*/React.createElement("input", {
    className: styles$2.input,
    type: "checkbox",
    checked: enabled,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$2.knob
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$2.grid
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$2.list
  }));
};
var styles$1 = {
  "root": "ToolbarButton-module_root__upsEH",
  "isDark": "ToolbarButton-module_isDark__gWpv-",
  "dark": "ToolbarButton-module_dark__5XOEp",
  "bookmark": "ToolbarButton-module_bookmark__7SWkm",
  "isActive": "ToolbarButton-module_isActive__N4kkV",
  "icon": "ToolbarButton-module_icon__Ldcgq",
  "text": "ToolbarButton-module_text__4R2a0"
};
const ToolbarButton = _ref59 => {
  let {
    type,
    theme,
    isActive,
    lang = 'ru',
    text,
    icon,
    onClick
  } = _ref59;
  const classNames = [[styles$1.root, true], [styles$1[type], !!styles$1[type]], [styles$1[theme], !!styles$1[theme] && !!theme], [styles$1.isActive, !!isActive]];
  const label = SocialLabels[lang][type];
  return /*#__PURE__*/React.createElement("button", {
    "data-testid": "toolbar-button",
    className: makeClassName(classNames),
    type: "button",
    onClick: event => onClick(event, type)
  }, icon && (/*#__PURE__*/React.createElement("div", {
    className: styles$1.icon
  }, /*#__PURE__*/React.createElement(SvgSymbol, {
    size: "medium",
    icon: icon,
    styleContext: "isInToolbar"
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles$1.text
  }, text || label));
};
var styles = {
  "root": "Tooltip-module_root__xK21R",
  "isCenterBottom": "Tooltip-module_isCenterBottom__-qv7D",
  "isLeftBottom": "Tooltip-module_isLeftBottom__0-f5z",
  "isCenterTop": "Tooltip-module_isCenterTop__xQ3Ql",
  "isLeftTop": "Tooltip-module_isLeftTop__yjKrV",
  "body": "Tooltip-module_body__5qgzu",
  "footer": "Tooltip-module_footer__swU9S"
};
const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
const Tooltip = _ref60 => {
  let {
    children,
    position
  } = _ref60;
  const [x, y] = position;
  const positionClass = `is${capitalizeFirstLetter(x)}${capitalizeFirstLetter(y)}`;
  return /*#__PURE__*/React.createElement("div", {
    className: makeClassName([[styles.root, true], [styles[positionClass], true]])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, children));
};
const TooltipFooter = _ref61 => {
  let {
    children
  } = _ref61;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, children);
};
export { AnnouncementInText, BookmarkButton, Button, ButtonLoader, CardTitle, ChapterBlock, Cover, DocumentItemsCount, DonatesTeaser, DotsOnImage, Dropdown, EmbedBlockContainer, Footnote, GroupedBlock, HalfBlock, Image, ImportantLead, Lazy, ListBlock, ListViewSwitcher, MaterialNote, MaterialTitle, MediaCaption, Menu, Meta, MetaItem, MetaItemLive, Popover, Primary, QuoteBlock, RawHtmlBlock, RelatedBlock, RelatedRichBlock, RenderBlocks, RichTitle, Secondary, SensitiveBlock, ShopRelatedBlock, SimpleBlock, SimpleTitle, SourceBlock, Spoiler, SvgSymbol, Switcher, Table, Tag, Timestamp, Toolbar, ToolbarButton, ToolbarItem, Tooltip, TooltipFooter };